import React, { useState,useEffect } from "react";
import {
  Box,
  Text,
  HStack,
  VStack,
  Divider,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Grid,
  Image,
  Flex,
} from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import {GetPartnerData} from "../../../middleware/services/visits/patient-overview/updatedoctornotes"; 
import { useSignature } from "../../../auth";
const Prescription = ({
  drName,
  hospitalLogo,
  doctorQualification,
  doctorSpeciality,
  doctorPhone,
  doctorPhoneCountryCode,
  doctorMail,
  hospitalAddress,
  patientBookingId,
  patientmrnnumber,
  patientName,
  patientGender,
  patientAge,
  patientPhone,
  patientPhoneCountryCode,
  appointmentDate,
  patientdiagnosis,
  settings,
  hpi,
  hpitext,
  ros,
  vitalData,
  investigationData,
  chiefcomplaint,
  diagnosisData,
  medicalHistory,
  prescribedMedicines,
  scaleOut,
  recommendedTests,
  followUpDate,
  referralDoctor,
  referralDoctorSpeciality,
  doctorSignImage,
  followupDetail,
  generalnotes,
  dieticiannotes,
  documents,
  templateid,
  customtemplatevalues,
  physicalexam,
  time
}) => {

  // useEffect(() => {
  //   console.log("Referral Doctor : ", referralDoctor);
  // }, [])

  // const options = [
  //   "Referral to Higher Centers",
  //   "Nutrition packs for pregnant women",
  //   "ECG",
  //   "LABs",
  //   "USG Scanning for Ante Natal/others",
  //   "IV Fluids",
  //   "Injectibles for Seasonal Diseases",
  //   "Neubilizations",
  //   "MOT Procedures",
  //   "Other Minor OT",
  //   "IP Cases",
  //   "Physiotherapy Care",
  //   "Ambulance Service"
  // ];
  
  const [partnerData, setpartnerData] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const doctorId = params.get("doctorId");
  //const isClientLetterheadUser = true;

  // useEffect(() => {
  //   fetchPartnerDetials();
  //   console.log('doctorSignImage: ', doctorSignImage)
  // }, []);
  const fetchPartnerDetials = async () => {
    const inputToFetch = {
      input: {
       doctorid: doctorId,
      
      },
    };
   
    try {
    

      const response = await GetPartnerData(inputToFetch.input);
     
      if(response.output.result == "success"){
        const data = response?.output?.data;
        //console.log(data)
        setpartnerData(data);
      }
    
      //console.log(response)

   
    }
    catch (error) {
      console.error("Error fetching Doctor Notes data:", error);
    } 
  };
  const generateDynamicText = (value) => {
    let outputTexts = [];

    value.forEach((item, index) => {
      // Extract patient details
      let gender = patientGender || "";
      let age = patientAge || "";

      // Initialize attributes
      let attributes = {};
      item.details.forEach((attribute) => {
        switch (attribute.attribute) {
          case "Site":
            attributes.site = attribute.values.map((v) => v.value).join(", ");
            break;
          case "Onset":
            attributes.onset = attribute.value;
            break;
          case "Chronicity":
            attributes.chronicity = attribute.value;
            break;
          case "Onset Quality":
            attributes.onsetQuality = attribute.value;
            break;
          case "Frequency":
            attributes.frequency = attribute.value;
            break;
          case "Associated Symptoms":
            attributes.symptoms = attribute.values
              .map((v) => v.value)
              .join(", ");
            break;
          case "Rating Scale":
            attributes.ratingScale = attribute.value;
            break;
          case "Time":
            attributes.time = attribute.value;
            break;
          case "Time Value":
            attributes.timeValue = attribute.value;
            break;
          default:
            break;
        }
      });

      // Construct patient text for the first item
      let patientText =
        index === 0
          ? `The patient is a ${age}-year-old individual (${gender}) `
          : "";

      // Build template with conditional inclusion based on available data
      let template = `${patientText}`;

      if (attributes.site) {
        template += `presenting with ${attributes.site} ${item.type}. `;
      }

      if (attributes.onset) {
        template += `The ${item.type} started ${attributes.onset} and `;
        if (attributes.chronicity) {
          template += `is described as ${attributes.chronicity} in nature. `;
        }
      }

      if (attributes.onsetQuality) {
        template += `The onset of the ${item.type} was ${attributes.onsetQuality}. `;
      }

      if (attributes.frequency) {
        template += `The ${item.type} is ${attributes.frequency} and `;
      }

      if (attributes.ratingScale) {
        template += `is rated as ${attributes.ratingScale} out of 10 in intensity. `;
      }

      if (attributes.symptoms) {
        template += `Associated with ${attributes.symptoms}.`;
      }

      // Push the template to the outputTexts array
      outputTexts.push(template.trim());
    });

    return outputTexts;
  };
  const generateOptions = (followupDetail) => {
    // Ensure followupDetail is a valid object
    followupDetail = followupDetail || {};
  
    const mappings = {
      referraltohighercenters: "Referral to Higher Centers",
      nutritionpacksforpregnantwomen: "Nutrition packs for pregnant women",
      ecg: "ECG",
      labs: "LABs",
      usgscanningforantenatalothers: "USG Scanning for Ante Natal/others",
      ivfluids: "IV Fluids",
      injectiblesforseasonaldiseases: "Injectibles for Seasonal Diseases",
      nebulizations: "Nebulizations",
      motprocedures: "MOT Procedures",
      otherminorot: "Other Minor OT",
      ipcases: "IP Cases",
      physiotherapycare: "Physiotherapy Care",
      ambulanceservice: "Ambulance Service",
    };
  
    return Object.entries(mappings)
      .filter(([key]) => followupDetail[key] === 1)
      .map(([, value]) => value);
  };

  const options = generateOptions(followupDetail);

  const services = options?.length > 0;
  // Space values from template (support legacy verticalheight/verticalwidth too)
  const leftSpace = customtemplatevalues?.left || customtemplatevalues?.verticalheight || "";
  const rightSpace = customtemplatevalues?.right || customtemplatevalues?.verticalwidth || "";
  const topSpace = customtemplatevalues?.top || customtemplatevalues?.header || "";
  const bottomSpace = customtemplatevalues?.bottom || customtemplatevalues?.footer || "";
  // Normalize units: if value is numeric (or numeric string) assume mm, otherwise keep as-is
  const normalizeUnit = (v) => {
    if (v === undefined || v === null || v === '') return undefined;
    if (typeof v === 'number') return `${v}mm`;
    if (typeof v === 'string') {
      const trimmed = v.trim();
      if (/^[0-9.]+$/.test(trimmed)) return `${trimmed}mm`;
      return trimmed;
    }
    return String(v);
  };
  const leftSpaceCss = normalizeUnit(leftSpace);
  const rightSpaceCss = normalizeUnit(rightSpace);
  const topSpaceCss = normalizeUnit(topSpace);
  const bottomSpaceCss = normalizeUnit(bottomSpace);
  // debug: log incoming template values and computed spacing
  React.useEffect(() => {
    try {
      // eslint-disable-next-line no-console
      console.log("[Prescription] customtemplatevalues:", customtemplatevalues, "topSpaceCss:", topSpaceCss);
    } catch (e) {}
  }, [customtemplatevalues, topSpaceCss]);
  // Parse numeric mm value and clamp large/invalid bottom values so the box stays on the page
  const parseToMm = (v) => {
    if (!v) return 0;
    const match = String(v).trim().match(/^([0-9.]+)\s*(mm|cm|px)?$/i);
    if (!match) return 0;
    const num = parseFloat(match[1]);
    const unit = (match[2] || 'mm').toLowerCase();
    if (unit === 'cm') return num * 10; // 1cm = 10mm
    if (unit === 'mm') return num;
    if (unit === 'px') return num * 0.264583; // px -> mm (approx)
    return num;
  };
  const clampMm = (mm, maxMm = 80) => {
    if (!mm || isNaN(mm)) return 0;
    return Math.min(mm, maxMm);
  };
  const bottomSpaceMm = clampMm(parseToMm(bottomSpaceCss));
  const bottomSpaceCssUsed = bottomSpaceMm ? `${bottomSpaceMm}mm` : undefined;
  

  //----------------------------
  const chunkArray = (array, size) => {
    if (!array || array.length === 0) {
      return [];
    }
    const chunkedArr = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArr.push(array.slice(i, i + size));
    }
    return chunkedArr;
  };

  const middleSectionHeaderWidth = 20;
  const calculateContentColumnWidth = (array, headerWidth) => {
    const columnCount = array.length;
    const remainingWidth = 100 - headerWidth;
    const columnWidth = remainingWidth / columnCount;
    return columnWidth;
  };

  const chunkedDiagnosisData = chunkArray(diagnosisData, scaleOut ? 2 : 3);

  const chunkedMedicalHistory = chunkArray(medicalHistory, 2);
  const chunkedRecommendedTests = chunkArray(recommendedTests, 2);
  const chunkedGeneralNotes = chunkArray(generalnotes, 1);
  const chunkedDieticianNotes = chunkArray(dieticiannotes, 1);
  const medicinesPerPage = 10;

//Process to display the tablets depending on the data we have in first page
  const baseFirstPageCount = 8;
  const reducedFirstPageCount = 1; // if all sections present
  const restPageCount = 15;
  let tabletNumberOffset = 0;
  let chunkedMedicines = [];

  const hashpi = hpi?.length > 0 || hpitext;
  const hasVitals = settings?.vitals === 1 && vitalData?.length > 0;
  const hasRos = settings?.ros === 1 && ros?.length > 0;
  const hasPhysicalExam = settings?.physicalexam === 1 && physicalexam?.length > 0;
  const hasAssessment = settings?.assessment === 1 && diagnosisData?.length > 0;
  const hasdiet = dieticiannotes?.length > 0;
  const hasgeneralnotes = generalnotes?.length > 0;
  const shouldReduceFirstPage = hashpi && hasVitals && hasRos && hasPhysicalExam && hasAssessment;
  const firstPageCount = shouldReduceFirstPage ? reducedFirstPageCount : baseFirstPageCount;

  useEffect(() => {
    console.log('Prescribed medicines Prescription: ', prescribedMedicines)
  }, [prescribedMedicines])
  if (prescribedMedicines && prescribedMedicines.length > 0) {
    chunkedMedicines.push(prescribedMedicines.slice(0, firstPageCount));

    for (let i = firstPageCount; i < prescribedMedicines.length; i += restPageCount) {
      chunkedMedicines.push(prescribedMedicines.slice(i, i + restPageCount));
    }
  }

  // Chunk the prescribed medicines into groups of 10
  //const chunkedMedicines = chunkArray(prescribedMedicines, medicinesPerPage);
  const Esign = useSignature(doctorSignImage,{
    size:18,
    color:"#4a5568",
  })
  // Helper function to capitalize first letter
const capitalizeFirstLetter = (string) => {
  if (!string || typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};
const formatMedicineName = (medicine) => {
  if (!medicine) return "";
  
  const type = medicine.medicinetype?.toLowerCase() || medicine.type?.toLowerCase() || "";
  const name = medicine.name || "";
  const dosage = medicine.dosage || "";
  const dosageUnit = medicine.dosageunit || "";
  
  // Capitalize first letter of medicine name
  const capitalizedName = name && name.length > 0 
    ? name.charAt(0).toUpperCase() + name.slice(1) 
    : "";
  
  let formattedName = capitalizedName;
  
  // Add type prefix - map each type to its shortform
  if (type.includes("tab") || type === "tablet") {
    formattedName = `Tab. ${capitalizedName}`;
  } else if (type.includes("cap") || type === "capsule") {
    formattedName = `Cap. ${capitalizedName}`;
  } else if (type.includes("syr") || type === "syrup") {
    formattedName = `Syr. ${capitalizedName}`;
  } else if (type.includes("inj") || type === "injection") {
    formattedName = `Inj. ${capitalizedName}`;
  } else if (type.includes("cream")) {
    formattedName = `Crm. ${capitalizedName}`;
  } else if (type.includes("ointment")) {
    formattedName = `Oint. ${capitalizedName}`;
  } else if (type.includes("gel")) {
    formattedName = `Gel. ${capitalizedName}`;
  }
  
  // Add dosage if available
  if (dosage) {
    formattedName += `-${dosage}${dosageUnit}`;
  }
  
  return formattedName;
};


const formatFraction = (value) => {
  const num = parseFloat(value);
  if (num === 0.5) return "½";
  if (num === 0.25) return "¼";
  if (num === 0.75) return "¾";
  return num;
};
const formatPatternDose = (med) => {
  const perDose = parseFloat(med.frequency || 1);

  const slotValue = (slot) => {
    if (!slot || slot === "0") return "0";
    return formatFraction(perDose);
  };

  return `${slotValue(med.morning)}-${slotValue(med.afternoon)}-${slotValue(med.night)}`;
};
const getDoseDisplay = (med) => {
  // Ointment/Cream/Gel: show actual meal timing (morning-afternoon-night), one application per slot
  if (isTopicalType(med)) {
    return formatPatternDose({ ...med, frequency: 1 });
  }

  // Case 1: Frequency based (Daily / Hours etc.)
  if (med.frequencytime && med.frequencyvalue) {
    if (med.frequencytime === "Hours") {
      return `Every ${med.frequencyvalue} ${med.frequencytime}`;
    }

    return `${med.frequencytime} ${
      med.frequencyvalue === 1
        ? "once"
        : med.frequencyvalue === 2
        ? "twice"
        : med.frequencyvalue === 3
        ? "thrice"
        : `${med.frequencyvalue} times`
    }`;
  }

  // Case 2: Morning-Afternoon-Night pattern
  return formatPatternDose(med);
};

// const formatDoseWithQuantity = (med) => {
//   const qtyPerDose = parseFloat(med.frequency || 1);

//   const formatSlot = (slot) => {
//     if (!slot || slot === "0") return "0";
//     if (qtyPerDose === 0.5) return "½";
//     if (qtyPerDose === 0.25) return "¼";
//     return qtyPerDose;
//   };

//   return `${formatSlot(med.morning)}-${formatSlot(
//     med.afternoon
//   )}-${formatSlot(med.night)}`;
// };

const calculateTotalQty = (med) => {
  if (isTopicalType(med)) {
    const pqValue = parseFloat(med.productQuantity);
    if (!isNaN(pqValue) && pqValue >= 1 && pqValue <= 4) return pqValue;
    const freqValue = parseFloat(med.frequency);
    if (!isNaN(freqValue) && freqValue >= 1 && freqValue <= 4) return freqValue;
    const qtyApp = parseFloat(med.quantitytobeapplied);
    if (!isNaN(qtyApp) && qtyApp > 0) return qtyApp;
    return 1;
  }

  const perDose = parseFloat(med.frequency || 1);
  const days = med.duration > 0 ? med.duration : 0;

  const dailyCount =
    (med.morning === "1" ? 1 : 0) +
    (med.afternoon === "1" ? 1 : 0) +
    (med.night === "1" ? 1 : 0);

  const total = dailyCount * perDose * days;

  return total || 0;
};

const calculateQty = (med) => {
  // Ointment/Cream/Gel: QTY = product quantity only (no calculation). Value is sent in frequency by quickvisit.
  if (isTopicalType(med)) {
    const pqValue = parseFloat(med.productQuantity);
    if (!isNaN(pqValue) && pqValue >= 1 && pqValue <= 4) return pqValue;
    const freqValue = parseFloat(med.frequency);
    if (!isNaN(freqValue) && freqValue >= 1 && freqValue <= 4) return freqValue;
    const qtyApp = parseFloat(med.quantitytobeapplied);
    if (!isNaN(qtyApp) && qtyApp > 0) return qtyApp;
    return 1;
  }
  const perDose = parseFloat(med.frequency || 1);
  const days = med.duration > 0 ? med.duration : 0;

  // Case 1: Daily / Frequency based
  if (med.frequencytime && med.frequencyvalue) {
    let timesPerDay = parseFloat(med.frequencyvalue || 0);

    // If frequency is in Hours → convert to times per day
    if (med.frequencytime === "Hours") {
      timesPerDay = 24 / timesPerDay;
    }

    return Math.ceil(perDose * timesPerDay * days);
  }

  // Case 2: Morning-Afternoon-Night pattern
  const dailyCount =
    (med.morning === "1" ? 1 : 0) +
    (med.afternoon === "1" ? 1 : 0) +
    (med.night === "1" ? 1 : 0);

  return Math.ceil(perDose * dailyCount * days);
};

// Helper function to check if any medicine is topical (Cream/Ointment/Gel)
// helper to identify topical types
const isTopicalType = (med) => {
  const t = (med.medicinetype || med.type || "").toLowerCase() || "";
  return t === "syrup" || t === "cream" || t === "ointment" || t === "gel";
};

const hasTopicalMedicines = () => {
  return prescribedMedicines && prescribedMedicines.some(isTopicalType);
};


  return (
  <Box>
 <Box>
  {chunkedMedicines && chunkedMedicines.length > 0 ? (
    <Box>
      {chunkedMedicines.map((medicineChunk, pageIndex) => {
        const currentOffset = tabletNumberOffset;
        tabletNumberOffset += medicineChunk.length;
        
        return (
          <Box
            key={`page-${pageIndex}`}
            width="215mm"
            height="297mm"
            borderWidth="1px"
            borderColor="gray.200"
            position="relative"
            className="printPdf page-break"
          >
            {/* Side spaces for template 3 */}
            {Number(templateid) === 3 && rightSpaceCss && (
              <Box
                position="absolute"
                right="0"
                top={0}
                height="100%"
                width={rightSpaceCss}
                zIndex={1}
                bg={customtemplatevalues?.headerColor || "white"}
                borderLeft="1px solid #e6e6e6"
              />
            )}
            {Number(templateid) === 3 && leftSpaceCss && (
              <Box
                position="absolute"
                left={0}
                top={0}
                height="100%"
                width={leftSpaceCss}
                zIndex={1}
                bg={customtemplatevalues?.headerColor || "white"}
                borderRight="1px solid #e6e6e6"
              />
            )}

            {/* Header Section (only for non-template-3) */}
            {templateid !== 3 && templateid !== 4 && (
              <>
                <Box
                  mt="0px"
                  width="100%"
                  height="8px"
                  bg="blue.600"
                />
                <Box bg="#fafafa">
                  <HStack justify="space-between" pt={3} px={4}>
                    <VStack align="flex-start" spacing={1}>
                      <Text fontWeight="bold" fontSize="xl">
                        {drName}
                      </Text>
                      <Text>
                        {doctorQualification}, {doctorSpeciality}
                      </Text>
                    </VStack>
                    <HStack spacing={4} px={4}>
                      {partnerData.slice(0, 3).map((partner, index) => (
                        <Box
                          key={index}
                          ml={index > 0 ? 2 : 0}
                          display="flex"
                          alignItems="center"
                          style={{ position: "relative", top: "-4px" }}
                        >
                          {partner.partnerlogo ? (
                            <Image
                              src={partner.imagepath + partner.partnerlogo}
                              alt={`Partner Logo ${index + 1}`}
                              height="40px"
                              width="40px"
                              borderRadius="50%"
                              cursor="pointer"
                            />
                          ) : (
                            <Box
                              color="black"
                              height="40px"
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              borderRadius="4px"
                              cursor="pointer"
                            >
                              {partner.partnername.trim()}
                            </Box>
                          )}
                        </Box>
                      ))}
                      <Box
                        ml="0"
                        display="flex"
                        alignItems="center"
                        style={{ position: "relative", top: "-4px" }}
                      >
                        {hospitalLogo && (
                          <img
                            src={hospitalLogo}
                            alt="Hospital Logo"
                            height="40px"
                            width="40px"
                          />
                        )}
                      </Box>
                      <Image
                        src="assets/svgs/bigLineLogo.svg"
                        alt="Big Line Logo"
                      />
                      <Image
                        src="assets/svgs/miDocLogo.svg"
                        alt="miDoc Logo"
                        height="40px"
                        mr="36px"
                      />
                    </HStack>
                  </HStack>

                  <HStack justify="flex-start" mt={1} px={4}>
                    <HStack>
                      <Image src="assets/svgs/call.svg" alt="Call" />
                      <Text fontSize="xs">
                        {doctorPhoneCountryCode && `(${doctorPhoneCountryCode}) `}
                        {doctorPhone}
                      </Text>
                    </HStack>
                    <HStack>
                      <Image
                        src="assets/svgs/smallLinePhoneMail.svg"
                        alt="Divider"
                      />
                      <Image src="assets/svgs/mail-gray.svg" alt="Mail" />
                      <Text fontSize="xs">{doctorMail}</Text>
                    </HStack>
                  </HStack>

                  <HStack justify="flex-start" mt={1} px={4}>
                    <Image
                      src="assets/svgs/hospital-location-on.svg"
                      alt="Location"
                    />
                    <Text fontSize="xs">{hospitalAddress}</Text>
                  </HStack>
                </Box>
              </>
            )}

            {/* Template 4 Header */}
            {templateid === 4 && (
              <Box
                bg={customtemplatevalues?.headerColor || "#fafafa"}
                p="0.75rem"
                mt={topSpaceCss || 0}
              >
                <div
                  style={{ width: "100%" }}
                  dangerouslySetInnerHTML={{
                    __html: customtemplatevalues?.headerHtml || "",
                  }}
                />
              </Box>
            )}

            {/* Main Content Area - Dynamically positioned between side spaces */}
            {templateid === 3 || templateid === 4 ? (
            <Box
              position="absolute"
              left={Number(templateid) === 3 && leftSpace ? leftSpace : 0}
              right={Number(templateid) === 3 && rightSpaceCss ? rightSpaceCss : 0}
              top={topSpaceCss ? topSpaceCss : 0}
              bottom={0}
              p={scaleOut ? 1 : 4}
              px={scaleOut ? 2 : 4}
              pt={Number(templateid) === 3 ? "16px" : "16px"}
              overflow="hidden"
              display="flex"
              flexDirection="column"
            >
              {/* Patient Information Section - Only on first page */}
              {pageIndex === 0 && (
                <>
                  <VStack align="flex-start" mt={scaleOut ? "1px" : "4px"} width="100%">
                    <HStack width="100%" justifyContent="space-between" alignItems="flex-start">
                      <VStack spacing={1} align="start" width="100%">
                        <HStack width="100%" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            # {patientBookingId}
                          </Text>
                          <Text
                            fontWeight="bold"
                            fontSize={scaleOut ? "sm" : "md"}
                            flex={1}
                            minWidth={0}
                          >
                            {patientName && `${patientName}, `}
                          </Text>
                          <Text
                            fontWeight="bold"
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            {patientmrnnumber && `#${patientmrnnumber}`}
                          </Text>
                        </HStack>

                        <HStack width="100%" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Details:
                          </Text>
                          <Text
                            fontWeight="bold"
                            fontSize={scaleOut ? "sm" : "md"}
                            flex={1}
                            minWidth={0}
                            wordBreak="break-word"
                          >
                            {[
                              patientGender &&
                                patientGender.charAt(0).toUpperCase() +
                                  patientGender.slice(1),
                              patientAge && `${patientAge} Yrs`,
                              patientPhone &&
`${patientPhoneCountryCode ? `(${patientPhoneCountryCode}) ` : ""}${patientPhone}`,

                              // (patientPhoneCountryCode || patientPhone) &&
                              //   `${
                              //     patientPhoneCountryCode
                              //       ? `(${patientPhoneCountryCode}) `
                              //       : ""
                              //   }${patientPhone}`,
                              appointmentDate,
                              ...(vitalData && Array.isArray(vitalData)
                                ? vitalData
                                    .filter(
                                      (vital) =>
                                        vital.type === "Weight" ||
                                        vital.type === "Height"
                                    )
                                    .map(
                                      (vital) =>
                                        `VITAL|${vital.type}|${vital.value}`
                                    )
                                : []),
                            ]
                              .filter(Boolean)
                              .map((item, index, arr) => {
                                const isVital = item.startsWith("VITAL|");

                                if (isVital) {
                                  const [, label, value] = item.split("|");
                                  return (
                                    <Box as="span" key={index}>
                                      <b>{label}</b>:{" "}
                                      <Text as="span" fontWeight="normal">
                                        {value}
                                      </Text>
                                      {index !== arr.length - 1 ? ", " : ""}
                                    </Box>
                                  );
                                }

                                return (
                                  <Box as="span" key={index}>
                                    {item}
                                    {index !== arr.length - 1 ? ", " : ""}
                                  </Box>
                                );
                              })}
                          </Text>
                        </HStack>
                      </VStack>

                      {templateid == 3 && (
                        <Image
                          src="assets/svgs/miDocLogo.svg"
                          alt="miDoc Logo"
                          height="40px"
                          ml="16px"
                          flexShrink={0}
                        />
                      )}
                    </HStack>

                    {services && (
                      <HStack width="100%" mt="4px" alignItems="flex-start">
                        <Text
                          width={`${middleSectionHeaderWidth}%`}
                          fontSize={scaleOut ? "sm" : "md"}
                          flexShrink={0}
                        >
                          Services:
                        </Text>
                        <Text
                          fontWeight="bold"
                          fontSize={scaleOut ? "sm" : "md"}
                          width={`${100 - middleSectionHeaderWidth}%`}
                          wordBreak="break-word"
                        >
                          {options.join(", ")}
                        </Text>
                      </HStack>
                    )}

                    <Divider my={scaleOut ? 1 : 2} />

                    {settings &&
                      settings.chiefcomplaint === 1 &&
                      chiefcomplaint && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Complaints:
                          </Text>
                          <Text
                            fontWeight="bold"
                            fontSize={scaleOut ? "sm" : "md"}
                            flex={1}
                            wordBreak="break-word"
                          >
                            {chiefcomplaint}
                          </Text>
                        </HStack>
                      )}

                    {settings &&
                      settings.hpi === 1 &&
                      (hpitext || (hpi && hpi.length > 0)) && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Present Illness:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            wordBreak="break-word"
                          >
                            {hpitext ? (
                              <>{hpitext}</>
                            ) : (
                              generateDynamicText(hpi).map((text, index) => (
                                <React.Fragment key={index}>
                                  {text}
                                </React.Fragment>
                              ))
                            )}
                          </Text>
                        </HStack>
                      )}

                    {settings &&
                      settings.vitals === 1 &&
                      vitalData &&
                      vitalData.length > 0 && (
                        <HStack width="100%" gap="20px" alignItems="flex-start">
                          <Box w="20%">
                            <Text
                              width="100%"
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Vitals:
                            </Text>
                          </Box>
                          <Box
                            w="100%"
                            display="flex"
                            flexWrap="wrap"
                            gap="10px"
                          >
                            {vitalData
                              .filter(
                                (vital) =>
                                  vital.type !== "Weight" &&
                                  vital.type !== "Height"
                              )
                              .map((vital, index) => (
                                <Text
                                  key={index}
                                  fontSize={
                                    scaleOut || vitalData.length > 3
                                      ? "sm"
                                      : undefined
                                  }
                                >
                                  <b>{vital.type}</b>: {vital.value}{" "}
                                  {vital.unit}
                                </Text>
                              ))}
                          </Box>
                        </HStack>
                      )}

                    {settings &&
                      settings.physicalexam === 1 &&
                      physicalexam &&
                      physicalexam.length > 0 && (
                        <HStack
                          width="100%"
                          gap="20px"
                          alignItems="flex-start"
                        >
                          <Box w="20%">
                            <Text
                              width="100%"
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Physical Exam:
                            </Text>
                          </Box>
                          <Box
                            w="100%"
                            display="flex"
                            flexWrap="wrap"
                            gap="10px"
                          >
                            {physicalexam.map((exam, index) => (
                              <Text
                                key={index}
                                fontSize={
                                  scaleOut || physicalexam.length > 3
                                    ? "sm"
                                    : undefined
                                }
                              >
                                <b>{exam.type}</b>: {exam.condition}
                                {exam.notes ? `, ${exam.notes}` : ""}
                              </Text>
                            ))}
                          </Box>
                        </HStack>
                      )}

                    {settings &&
                      settings.ros === 1 &&
                      ros &&
                      ros.length > 0 && (
                        <HStack
                          width="100%"
                          gap="20px"
                          alignItems="flex-start"
                        >
                          <Box w="20%">
                            <Text
                              width="100%"
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Review of system:
                            </Text>
                          </Box>
                          <Box
                            w="100%"
                            display="flex"
                            flexWrap="wrap"
                            gap="10px"
                          >
                            {ros.map((exam, index) => (
                              <Text
                                key={index}
                                fontSize={
                                  scaleOut || ros.length > 3 ? "sm" : undefined
                                }
                              >
                                <b>{exam.type}</b>: {exam.condition}
                              </Text>
                            ))}
                          </Box>
                        </HStack>
                      )}

                    {/* {investigationData && investigationData.length > 0 && ( */}
                    {Array.isArray(investigationData) &&
 investigationData.filter(i => i?.value).length > 0 && (
                      <HStack width="100%" alignItems="flex-start">
                        <Text
                          width={`${middleSectionHeaderWidth}%`}
                          fontSize={scaleOut ? "sm" : "md"}
                          flexShrink={0}
                        >
                          Investigations:
                        </Text>
                        <Box display="flex" flexWrap="wrap" gap="10px" flex={1}>
                          {investigationData.map((investigate, index) => (
                            <Text
                              key={index}
                              fontSize={
                                scaleOut || investigationData.length > 3
                                  ? "sm"
                                  : undefined
                              }
                            >
                              <b>{investigate.type}</b>: {investigate.value}{" "}
                              {investigate.unit}
                            </Text>
                          ))}
                        </Box>
                      </HStack>
                    )}

                    {settings &&
                      settings.assessment === 1 &&
                      (patientdiagnosis ||
                        chunkedDiagnosisData?.length > 0) && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Diagnosis:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            fontWeight="bold"
                            wordBreak="break-word"
                          >
                            {patientdiagnosis}
                            {patientdiagnosis &&
                            chunkedDiagnosisData?.length > 0
                              ? ", "
                              : ""}
                            {chunkedDiagnosisData?.flat()?.join(", ")}
                          </Text>
                        </HStack>
                      )}

                    {/* {chunkedMedicalHistory &&
                      chunkedMedicalHistory.length > 0 && ( */}
                      {Array.isArray(chunkedMedicalHistory) &&
 chunkedMedicalHistory.flat().filter(Boolean).length > 0 && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Medical History:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            fontWeight="bold"
                            wordBreak="break-word"
                          >
                            {chunkedMedicalHistory.flat().join(", ")}
                          </Text>
                        </HStack>
                      )}

                    {/* {chunkedRecommendedTests &&
                      chunkedRecommendedTests.length > 0 && ( */}
                      {Array.isArray(chunkedRecommendedTests) &&
 chunkedRecommendedTests.flat().filter(Boolean).length > 0 && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Recommended Tests:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            fontWeight="bold"
                            wordBreak="break-word"
                          >
                            {chunkedRecommendedTests
                              .flat()
                              .filter(Boolean)
                              .map((test, index, array) => (
                                <span key={index}>
                                  {test}
                                  {index !== array.length - 1 ? ", " : ""}
                                </span>
                              ))}
                          </Text>
                        </HStack>
                      )}

                    {/* {chunkedDieticianNotes &&
                      chunkedDieticianNotes.length > 0 && ( */}
                      {Array.isArray(chunkedDieticianNotes) &&
 chunkedDieticianNotes.flat().filter(Boolean).length > 0 && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Dietician Notes:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            fontWeight="bold"
                            wordBreak="break-word"
                          >
                            {chunkedDieticianNotes.flat().join(", ")}
                          </Text>
                        </HStack>
                      )}

                    {/* {chunkedGeneralNotes &&
                      chunkedGeneralNotes.length > 0 && ( */}
                      {Array.isArray(chunkedGeneralNotes) &&
 chunkedGeneralNotes.flat().filter(Boolean).length > 0 && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            General Notes:
                          </Text>
                          <Text
                            width={`${100 - middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            fontWeight="bold"
                            wordBreak="break-word"
                          >
                            {chunkedGeneralNotes.flat().join(", ")}
                          </Text>
                        </HStack>
                      )}
                  </VStack>

                  {/* Only show a divider and extra spacing if there is any diagnosis/history/notes content above */}
                  {(
                    (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
                    (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
                    (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
                    (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
                    (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
                  ) && (
                    <Divider my={scaleOut ? 1 : 3} />
                  )}

                  {/* Prescription Header */}
                  <HStack
                    mt={
                      (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
                      (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
                        ? 3
                        : 1
                    }
                  >
                    <Image
                      src="assets/svgs/Rx.svg"
                      alt="Rx"
                      boxSize={scaleOut ? "12px" : "24px"}
                    />
                    <Text fontWeight="bold" fontSize={scaleOut ? "sm" : "lg"}>
                      Prescription
                    </Text>
                  </HStack>
                </>
              )}

              {/* Medicine Table - Scrollable container newly added because of design break in preview */}
              <Box
                flex={1}
                mt={1}
                mb="80px"
              >
                <Table
                  variant="simple"
                  size="sm"
                  border="1px solid #e2e8f0"
                  borderRadius="lg"
                  width="100%"
                  sx={{
                    tableLayout: "fixed",
                    "& th, & td": {
                      padding: scaleOut ? "2px 4px" : "4px 8px",
                      fontSize: scaleOut ? "10px" : "12px",
                      lineHeight: 1.2,
                      verticalAlign: "top",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      minWidth: "0",
                    },
                  }}
                >
                  <Thead bg="#fafafa">
                    <Tr>
                      <Th width="38%" minWidth="120px">Medicine</Th>
                      <Th width="12%" minWidth="60px">Dose</Th>
                      <Th width="18%" minWidth="80px">Timing</Th>
                      <Th width="14%" minWidth="60px">Duration</Th>
                      <Th width="8%" minWidth="50px">QTY</Th>
                      <Th
                        width="12%"
                        minWidth="90px"
                        whiteSpace="normal"
                      >
                        Where to apply
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {medicineChunk.map((med, index) => (
                      <React.Fragment key={index}>
                        {/* Main Medicine Row */}
                        <Tr>
                          <Td fontWeight="bold">
                            <Box>
                              <Text
                                fontSize={scaleOut ? "xs" : "sm"}
                                fontWeight="bold"
                                wordBreak="break-word"
                              >
                                {currentOffset + index + 1}.{" "}
                                {formatMedicineName(med)}
                                {med.dosageforprescription &&
                                  ` (${med.dosageforprescription})`}
                              </Text>
                              {med.chemicalcomposition && (
                                <Text
                                  fontSize="9px"
                                  color="gray.500"
                                  mt="1px"
                                  fontStyle="italic"
                                  wordBreak="break-word"
                                >
                                  Composition: {med.chemicalcomposition}
                                </Text>
                              )}
                            </Box>
                          </Td>
                          <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {getDoseDisplay(med)}
  </Text>
</Td>
                          <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
  {(med.medicinetype || med.type || "").toLowerCase() === "syrup"
      ? (med.timing || "After Food")
      : isTopicalType(med)
        ? (med.applicationtiming || "-")
        : (med.timing || "After Food")}
  </Text>
</Td>
                          {/* <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {isTopicalType(med)
      ? (med.applicationtiming || "-")
      : med.timing || "After Food"}
  </Text>
</Td> */}
                          <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {isTopicalType(med)
      ? "Regular"
      : med?.duration !== -1
      ? `${med.duration || "0"} days`
      : "Regular"}
  </Text>
</Td>

<Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {calculateQty(med)}
  </Text>
</Td>

<Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {isTopicalType(med) ? (med.wheretoapply || "-") : "-"}
  </Text>
</Td>
                          {/* <Td>
                            <Text 
                              fontSize={scaleOut ? "xs" : "sm"}
                              wordBreak="break-word"
                            >
                              {med?.duration !== -1
                                ? `${med.duration || "0"} days`
                                : "Regular"}
                            </Text>
                          </Td> */}
                        </Tr>
                        {med.customtext && (
                          <Tr>
                            <Td
                              // colSpan={5}
                              colSpan={6}
                              fontSize={scaleOut ? "xs" : "sm"}
                              pl={4}
                              pt={0}
                              pb={1}
                              borderBottom="1px solid #e2e8f0"
                            >
                              <Text fontWeight="medium" display="inline">
                                Instructions:{" "}
                              </Text>
                              <Text display="inline">{med.customtext}</Text>
                            </Td>
                          </Tr>
                        )}
                        {/* Instructions Row - Full width */}
                        {/* {med.customtext && (
                          <Tr>
                            <Td 
                              colSpan={4} 
                              // bg="#f8f9fa"
                              borderTop="1px dashed #e2e8f0"
                              py="6px"
                            >
                              <Box pl={2}>
                                <Text 
                                  fontSize={scaleOut ? "xs" : "sm"}
                                  wordBreak="break-word"
                                  whiteSpace="pre-wrap"
                                  display="flex"
                                  alignItems="flex-start"
                                >
                                  <Text 
                                    as="span" 
                                    fontWeight="medium" 
                                    minWidth="80px"
                                    flexShrink={0}
                                  >
                                    Instructions: 
                                  </Text>
                                  <Text as="span" ml={1}>
                                    {med.customtext}
                                  </Text>
                                </Text>
                              </Box>
                            </Td>
                          </Tr>
                        )} */}
                      </React.Fragment>
                    ))}
                  </Tbody>
                </Table>
              </Box>

              {/* Medicine Table - Scrollable container existing */}
              {/* <Box
                flex={1}
                overflowY="auto"
                mt={2}
                mb="100px"
                sx={{
                  "&::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#888",
                    borderRadius: "2px",
                  },
                }}
              >
                <Table
                  variant="simple"
                  size="sm"
                  border="1px solid #e2e8f0"
                  borderRadius="lg"
                  width="100%"
                  sx={{
                    tableLayout: "fixed",
                    "& th, & td": {
                      padding: scaleOut ? "4px 6px" : "8px 10px",
                      fontSize: scaleOut ? "11px" : "13px",
                      verticalAlign: "top",
                    },
                  }}
                >
                  <Thead bg="#fafafa">
                    <Tr>
                      <Th width="45%">Medicine</Th>
                      <Th width="15%">Dose</Th>
                      <Th width="20%">Timing - Quantity</Th>
                      {hasTopicalMedicines() && (
                        <Th width="15%" whiteSpace="normal">
                          Where to apply
                        </Th>
                      )}
                      <Th width={hasTopicalMedicines() ? "10%" : "20%"}>Duration</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {medicineChunk.map((med, index) => (
                      <React.Fragment key={index}>
                        <Tr>
                          <Td fontWeight="bold">
                            <Box>
                              <Text
                                fontSize={scaleOut ? "xs" : "sm"}
                                fontWeight="bold"
                                noOfLines={2}
                              >
                                {currentOffset + index + 1}.{" "}
                                {formatMedicineName(med)}
                                {med.dosageforprescription &&
                                  ` (${med.dosageforprescription})`}
                              </Text>
                              {med.chemicalcomposition && (
                                <Text
                                  fontSize="9px"
                                  color="gray.500"
                                  mt="1px"
                                  fontStyle="italic"
                                >
                                  Composition: {med.chemicalcomposition}
                                </Text>
                              )}
                            </Box>
                          </Td>
                          <Td>
                            <Text fontSize={scaleOut ? "xs" : "sm"}>
                              {med.frequencytime && med.frequencyvalue
                                ? med.frequencytime === "Hours"
                                  ? `Every ${med.frequencyvalue} ${med.frequencytime}`
                                  : `${med.frequencytime} ${
                                      med.frequencyvalue === 1
                                        ? "once"
                                        : med.frequencyvalue === 2
                                        ? "twice"
                                        : med.frequencyvalue === 3
                                        ? "thrice"
                                        : `${med.frequencyvalue} times`
                                    }`
                                : `${med.morning || "0"} - ${
                                    med.afternoon || "0"
                                  } - ${med.night || "0"}`}
                            </Text>
                          </Td>
                          <Td>
                            <Text fontSize={scaleOut ? "xs" : "sm"}>
                              {(((med.medicinetype || med.type || "").toLowerCase() === "cream") || ((med.medicinetype || med.type || "").toLowerCase() === "ointment") || ((med.medicinetype || med.type || "").toLowerCase() === "gel"))
                                ? (med.applicationtiming ? (med.applicationtiming + " - " + (med.frequency || "1") + " Qty") : "-")
                                : ((med.timing || "After Food") + " - " + (med.frequency || "1") + " Qty")}
                            </Text>
                          </Td>
                          <Td>
                            <Text fontSize={scaleOut ? "xs" : "sm"}>
                              {isTopicalType(med) ? (med.wheretoapply || "-") : "-"}
                            </Text>
                          </Td>
                          <Td>
                            <Text fontSize={scaleOut ? "xs" : "sm"}>
                              {(med.medicinetype?.toLowerCase() === "cream" || med.medicinetype?.toLowerCase() === "ointment" || med.medicinetype?.toLowerCase() === "gel")
                                ? "Regular"
                                : med?.duration !== -1
                                ? `${med.duration || "0"} days`
                                : "Regular"}
                            </Text>
                          </Td>
                        </Tr>
                        {med.customtext && (
                          <Tr>
                            <Td
                              colSpan={6}
                              fontSize={scaleOut ? "xs" : "sm"}
                              pl={6}
                              pt={0}
                              pb={2}
                              borderBottom="1px solid #e2e8f0"
                            >
                              <Text fontWeight="medium" display="inline">
                                Instructions:{" "}
                              </Text>
                              <Text display="inline">{med.customtext}</Text>
                            </Td>
                          </Tr>
                        )}
                      </React.Fragment>
                    ))}
                  </Tbody>
                </Table>
              </Box> */}

              {/* Fixed Footer Section at Bottom */}
              {/* ================= FIXED FOOTER (CORRECTED) ================= */}
<Box
  position="absolute"
  bottom={Number(templateid) === 3 && bottomSpaceCssUsed ? bottomSpaceCssUsed : "20px"}
  left="0"
  right="0"
  zIndex={2}
>

  <Box position="relative">

    {/* Watermark */}
    <Box
      position="absolute"
      bottom="0"
      left="0"
      width="100%"
      height="160px"
      zIndex={0}
      opacity={0.8}
      pointerEvents="none"
    >
      <Box position="absolute" left="0" bottom="0" width="50%">
        <img
          src="assets/imgs/PrescriptionVisualBg.png"
          alt="Watermark"
          style={{ width: "100%" }}
        />
      </Box>

      <Box position="absolute" right="0" bottom="0" width="50%">
        <img
          src="assets/imgs/PrescriptionVisualBg.png"
          alt="Watermark"
          style={{ width: "100%" }}
        />
      </Box>
    </Box>

    {/* Footer Content */}
    <Box position="relative" zIndex={2}>
      <Flex gap="16px">

        {/* Follow Up Box */}
        <Box
          flex="2"
          border="1px solid #e2e8f0"
          borderRadius="8px"
          p={scaleOut ? "6px" : "10px"}
          bg="white"
        >
          <Grid templateColumns="100px 1fr" gap={2}>
            <Text fontSize={scaleOut ? "xs" : "sm"}>Follow-up:</Text>
            <Text fontSize={scaleOut ? "xs" : "sm"}>
              <b>{followUpDate || "-"}</b>
            </Text>

            <Text fontSize={scaleOut ? "xs" : "sm"}>Referral:</Text>
            <Text fontSize={scaleOut ? "xs" : "sm"}>
              <b>{referralDoctor || "-"}</b>
            </Text>
          </Grid>
        </Box>

        {/* Signature Box */}
        <Box
          flex="1"
          border="1px solid #e2e8f0"
          borderRadius="8px"
          p={scaleOut ? "6px" : "10px"}
          bg="white"
          minH={scaleOut ? "60px" : "80px"}
        >
          <Flex justify="space-between" mb="6px">
            <Text fontSize={scaleOut ? "xs" : "sm"}>Signature</Text>
            <Text fontSize="0.75rem" fontWeight="500">
              {time}
            </Text>
          </Flex>

          {doctorSignImage && (
            <Box
              w="100%"
              textAlign="center"
              dangerouslySetInnerHTML={{ __html: Esign }}
            />
          )}
        </Box>

      </Flex>
    </Box>

  </Box>
</Box>
{/* ============================================================ */}


{/* Watermark Layer */}
{/* ===============================
    FOOTER WATERMARK (WORKING)
================================ */}
{/* <Box
  position="absolute"
  left={0}
  right={0}
  bottom={0}
  height="180px"
  zIndex={0}
  pointerEvents="none"
>
  Left Half
  <Box
    position="absolute"
    left="0"
    bottom="0"
    width="50%"
    height="100%"
  >
    <img
      src="assets/imgs/PrescriptionVisualBg.png"
      alt="Prescription Background"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        opacity: 0.8,
      }}
    />
  </Box>

  Right Half
  <Box
    position="absolute"
    right="0"
    bottom="0"
    width="50%"
    height="100%"
  >
    <img
      src="assets/imgs/PrescriptionVisualBg.png"
      alt="Prescription Background"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
        opacity: 0.8,
      }}
    />
  </Box>
</Box> */}

{/* Footer Content (Follow-up + Signature) */}
{/* <Box
  position="absolute"
  left={Number(templateid) === 3 && leftSpaceCss ? leftSpaceCss : 0}
  right={Number(templateid) === 3 && rightSpaceCss ? rightSpaceCss : 0}
  bottom={
    Number(templateid) === 3 && bottomSpaceCssUsed
      ? bottomSpaceCssUsed
      : "20px"
  }
  zIndex={2}
>
  <Box px={scaleOut ? 2 : 4}>
    <HStack justify="space-between" width="100%" alignItems="stretch">

      Follow-up / Referral
      <VStack
        align="flex-start"
        width="65%"
        border="1px solid #e2e8f0"
        borderRadius="lg"
        p={scaleOut ? "6px" : "10px"}
        bg="white"
      >
        <Grid
          templateColumns={scaleOut ? "auto 1fr" : "100px 1fr"}
          gap={scaleOut ? 1 : 2}
          alignItems="center"
        >
          <Text fontSize={scaleOut ? "xs" : "sm"}>Follow-up:</Text>
          <Text fontSize={scaleOut ? "xs" : "sm"}>
            <b>{followUpDate || "-"}</b>
          </Text>

          <Text fontSize={scaleOut ? "xs" : "sm"}>Referral:</Text>
          <Text fontSize={scaleOut ? "xs" : "sm"}>
            <b>{referralDoctor || "-"}</b>
          </Text>
        </Grid>
      </VStack>

      Signature
      <VStack
        align="flex-start"
        width="30%"
        border="1px solid #e2e8f0"
        borderRadius="lg"
        p={scaleOut ? "6px" : "10px"}
        bg="white"
      >
        <Flex justifyContent="space-between" width="100%" alignItems="center">
          <Text fontSize={scaleOut ? "xs" : "sm"}>Signature</Text>
          <Text
            fontSize={scaleOut ? "10px" : "0.75rem"}
            fontWeight="500"
          >
            {time}
          </Text>
        </Flex>

        {doctorSignImage && (
          <Text
            className="Esignature"
            w="100%"
            textAlign="center"
            fontSize={scaleOut ? "10px" : "sm"}
            dangerouslySetInnerHTML={{ __html: Esign }}
          />
        )}
      </VStack>

    </HStack>
  </Box>
</Box> */}


            </Box>
            ) : (
              /* NEW STRUCTURE FOR DEFAULT TEMPLATES (1 & 2) */
              <Box
                p={scaleOut ? 1 : 4}
                px={scaleOut ? 2 : 4}
                pt="16px"
                pb="auto"
                height="auto"
                position="relative"
              >
                {/* Patient Information Section - Only on first page */}
                {pageIndex === 0 && (
                  <>
                    <VStack align="flex-start" mt={scaleOut ? "1px" : "4px"} width="100%">
                      <HStack width="100%" justifyContent="space-between" alignItems="flex-start">
                        <VStack spacing={1} align="start" width="100%">
                          <HStack width="100%" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              # {patientBookingId}
                            </Text>
                            <Text
                              fontWeight="bold"
                              fontSize={scaleOut ? "sm" : "md"}
                              flex={1}
                              minWidth={0}
                            >
                              {patientName && `${patientName}, `}
                            </Text>
                            <Text
                              fontWeight="bold"
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              {patientmrnnumber && `#${patientmrnnumber}`}
                            </Text>
                          </HStack>

                          <HStack width="100%" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Details:
                            </Text>
                            <Text
                              fontWeight="bold"
                              fontSize={scaleOut ? "sm" : "md"}
                              flex={1}
                              minWidth={0}
                              wordBreak="break-word"
                            >
                              {[
                                patientGender &&
                                  patientGender.charAt(0).toUpperCase() +
                                    patientGender.slice(1),
                                patientAge && `${patientAge} Yrs`,
                                patientPhone &&
                                  `${
                                    patientPhoneCountryCode
                                      ? `(${patientPhoneCountryCode}) `
                                      : ""
                                  }${patientPhone}`,
                                appointmentDate,
                                ...(vitalData && Array.isArray(vitalData)
                                  ? vitalData
                                      .filter(
                                        (vital) =>
                                          vital.type === "Weight" ||
                                          vital.type === "Height"
                                      )
                                      .map(
                                        (vital) =>
                                          `VITAL|${vital.type}|${vital.value}`
                                      )
                                  : []),
                              ]
                                .filter(Boolean)
                                .map((item, index, arr) => {
                                  const isVital = item.startsWith("VITAL|");

                                  if (isVital) {
                                    const [, label, value] = item.split("|");
                                    return (
                                      <Box as="span" key={index}>
                                        <b>{label}</b>:{" "}
                                        <Text as="span" fontWeight="normal">
                                          {value}
                                        </Text>
                                        {index !== arr.length - 1 ? ", " : ""}
                                      </Box>
                                    );
                                  }

                                  return (
                                    <Box as="span" key={index}>
                                      {item}
                                      {index !== arr.length - 1 ? ", " : ""}
                                    </Box>
                                  );
                                })}
                            </Text>
                          </HStack>
                        </VStack>
                      </HStack>

                      {services && (
                        <HStack width="100%" mt="4px" alignItems="flex-start">
                          <Text
                            width={`${middleSectionHeaderWidth}%`}
                            fontSize={scaleOut ? "sm" : "md"}
                            flexShrink={0}
                          >
                            Services:
                          </Text>
                          <Text
                            fontWeight="bold"
                            fontSize={scaleOut ? "sm" : "md"}
                            width={`${100 - middleSectionHeaderWidth}%`}
                            wordBreak="break-word"
                          >
                            {options.join(", ")}
                          </Text>
                        </HStack>
                      )}

                      <Divider my={scaleOut ? 1 : 2} />

                      {settings &&
                        settings.chiefcomplaint === 1 &&
                        chiefcomplaint && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Complaints:
                            </Text>
                            <Text
                              fontWeight="bold"
                              fontSize={scaleOut ? "sm" : "md"}
                              flex={1}
                              wordBreak="break-word"
                            >
                              {chiefcomplaint}
                            </Text>
                          </HStack>
                        )}

                      {settings &&
                        settings.hpi === 1 &&
                        (hpitext || (hpi && hpi.length > 0)) && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Present Illness:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              wordBreak="break-word"
                            >
                              {hpitext ? (
                                <>{hpitext}</>
                              ) : (
                                generateDynamicText(hpi).map((text, index) => (
                                  <React.Fragment key={index}>
                                    {text}
                                  </React.Fragment>
                                ))
                              )}
                            </Text>
                          </HStack>
                        )}

                      {settings &&
                        settings.vitals === 1 &&
                        vitalData &&
                        vitalData.length > 0 && (
                          <HStack width="100%" gap="20px" alignItems="flex-start">
                            <Box w="20%">
                              <Text
                                width="100%"
                                fontSize={scaleOut ? "sm" : "md"}
                                flexShrink={0}
                              >
                                Vitals:
                              </Text>
                            </Box>
                            <Box
                              w="100%"
                              display="flex"
                              flexWrap="wrap"
                              gap="10px"
                            >
                              {vitalData
                                .filter(
                                  (vital) =>
                                    vital.type !== "Weight" &&
                                    vital.type !== "Height"
                                )
                                .map((vital, index) => (
                                  <Text
                                    key={index}
                                    fontSize={
                                      scaleOut || vitalData.length > 3
                                        ? "sm"
                                        : undefined
                                    }
                                  >
                                    <b>{vital.type}</b>: {vital.value}{" "}
                                    {vital.unit}
                                  </Text>
                                ))}
                            </Box>
                          </HStack>
                        )}

                      {settings &&
                        settings.physicalexam === 1 &&
                        physicalexam &&
                        physicalexam.length > 0 && (
                          <HStack
                            width="100%"
                            gap="20px"
                            alignItems="flex-start"
                          >
                            <Box w="20%">
                              <Text
                                width="100%"
                                fontSize={scaleOut ? "sm" : "md"}
                                flexShrink={0}
                              >
                                Physical Exam:
                              </Text>
                            </Box>
                            <Box
                              w="100%"
                              display="flex"
                              flexWrap="wrap"
                              gap="10px"
                            >
                              {physicalexam.map((exam, index) => (
                                <Text
                                  key={index}
                                  fontSize={
                                    scaleOut || physicalexam.length > 3
                                      ? "sm"
                                      : undefined
                                  }
                                >
                                  <b>{exam.type}</b>: {exam.condition}
                                  {exam.notes ? `, ${exam.notes}` : ""}
                                </Text>
                              ))}
                            </Box>
                          </HStack>
                        )}

                      {settings &&
                        settings.ros === 1 &&
                        ros &&
                        ros.length > 0 && (
                          <HStack
                            width="100%"
                            gap="20px"
                            alignItems="flex-start"
                          >
                            <Box w="20%">
                              <Text
                                width="100%"
                                fontSize={scaleOut ? "sm" : "md"}
                                flexShrink={0}
                              >
                                Review of system:
                              </Text>
                            </Box>
                            <Box
                              w="100%"
                              display="flex"
                              flexWrap="wrap"
                              gap="10px"
                            >
                              {ros.map((exam, index) => (
                                <Text
                                  key={index}
                                  fontSize={
                                    scaleOut || ros.length > 3 ? "sm" : undefined
                                  }
                                >
                                  <b>{exam.type}</b>: {exam.condition}
                                </Text>
                              ))}
                            </Box>
                          </HStack>
                        )}

                      {Array.isArray(investigationData) &&
                        investigationData.filter(i => i?.value).length > 0 && (
                          <HStack width="100%" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Investigations:
                            </Text>
                            <Box display="flex" flexWrap="wrap" gap="10px" flex={1}>
                              {investigationData.map((investigate, index) => (
                                <Text
                                  key={index}
                                  fontSize={
                                    scaleOut || investigationData.length > 3
                                      ? "sm"
                                      : undefined
                                  }
                                >
                                  <b>{investigate.type}</b>: {investigate.value}{" "}
                                  {investigate.unit}
                                </Text>
                              ))}
                            </Box>
                          </HStack>
                        )}

                      {settings &&
                        settings.assessment === 1 &&
                        (patientdiagnosis ||
                          chunkedDiagnosisData?.length > 0) && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Diagnosis:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              fontWeight="bold"
                              wordBreak="break-word"
                            >
                              {patientdiagnosis}
                              {patientdiagnosis &&
                              chunkedDiagnosisData?.length > 0
                                ? ", "
                                : ""}
                              {chunkedDiagnosisData?.flat()?.join(", ")}
                            </Text>
                          </HStack>
                        )}

                      {Array.isArray(chunkedMedicalHistory) &&
                        chunkedMedicalHistory.flat().filter(Boolean).length > 0 && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Medical History:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              fontWeight="bold"
                              wordBreak="break-word"
                            >
                              {chunkedMedicalHistory.flat().join(", ")}
                            </Text>
                          </HStack>
                        )}

                      {Array.isArray(chunkedRecommendedTests) &&
                        chunkedRecommendedTests.flat().filter(Boolean).length > 0 && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Recommended Tests:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              fontWeight="bold"
                              wordBreak="break-word"
                            >
                              {chunkedRecommendedTests
                                .flat()
                                .filter(Boolean)
                                .map((test, index, array) => (
                                  <span key={index}>
                                    {test}
                                    {index !== array.length - 1 ? ", " : ""}
                                  </span>
                                ))}
                            </Text>
                          </HStack>
                        )}

                      {Array.isArray(chunkedDieticianNotes) &&
                        chunkedDieticianNotes.flat().filter(Boolean).length > 0 && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              Dietician Notes:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              fontWeight="bold"
                              wordBreak="break-word"
                            >
                              {chunkedDieticianNotes.flat().join(", ")}
                            </Text>
                          </HStack>
                        )}

                      {Array.isArray(chunkedGeneralNotes) &&
                        chunkedGeneralNotes.flat().filter(Boolean).length > 0 && (
                          <HStack width="100%" mt="4px" alignItems="flex-start">
                            <Text
                              width={`${middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              flexShrink={0}
                            >
                              General Notes:
                            </Text>
                            <Text
                              width={`${100 - middleSectionHeaderWidth}%`}
                              fontSize={scaleOut ? "sm" : "md"}
                              fontWeight="bold"
                              wordBreak="break-word"
                            >
                              {chunkedGeneralNotes.flat().join(", ")}
                            </Text>
                          </HStack>
                        )}
                    </VStack>

                    {/* Only show spacing/divider when there is content above */}
                    {(
                      (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
                      (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
                      (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
                    ) && (
                      <Divider my={scaleOut ? 1 : 3} />
                    )}

                    {/* Prescription Header */}
                    <HStack
                      mt={
                        (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
                        (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
                        (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
                        (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
                        (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
                          ? 3
                          : 1
                      }
                    >
                      <Image
                        src="assets/svgs/Rx.svg"
                        alt="Rx"
                        boxSize={scaleOut ? "12px" : "24px"}
                      />
                      <Text fontWeight="bold" fontSize={scaleOut ? "sm" : "lg"}>
                        Prescription
                      </Text>
                    </HStack>
                  </>
                )}

                {/* Medicine Table newly added */}
                <Box
                  flex={1}
                  mt={1}
                  mb="80px"
                >
                  <Table
                    variant="simple"
                    size="sm"
                    border="1px solid #e2e8f0"
                    borderRadius="lg"
                    width="100%"
                    sx={{
                      tableLayout: "fixed",
                      "& th, & td": {
                        padding: scaleOut ? "2px 4px" : "4px 8px",
                        fontSize: scaleOut ? "10px" : "12px",
                        lineHeight: 1.2,
                        verticalAlign: "top",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        minWidth: "0",
                      },
                    }}
                  >
                    <Thead bg="#fafafa">
                      <Tr>
                        <Th width="40%" minWidth="120px">Medicine</Th>
                        <Th width="15%" minWidth="60px">Dose</Th>
                        {/* <Th width="20%" minWidth="80px">Timing - Quantity</Th> */}
                        <Th width="20%" minWidth="80px">Timing</Th>
                        <Th width="15%" minWidth="60px">Duration</Th>
                        <Th width="15%" minWidth="60px">QTY</Th>
                        <Th width="15%" minWidth="70px" whiteSpace="normal">
                          Where to apply
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {medicineChunk.map((med, index) => (
                        <React.Fragment key={index}>
                          {/* Main Medicine Row */}
                          <Tr>
                            <Td fontWeight="bold">
                              <Box>
                                <Text
                                  fontSize={scaleOut ? "xs" : "sm"}
                                  fontWeight="bold"
                                  wordBreak="break-word"
                                >
                                  {currentOffset + index + 1}.{" "}
                                  {formatMedicineName(med)}
                                  {med.dosageforprescription &&
                                    ` (${med.dosageforprescription})`}
                                </Text>
                                {med.chemicalcomposition && (
                                  <Text
                                    fontSize="9px"
                                    color="gray.500"
                                    mt="1px"
                                    fontStyle="italic"
                                    wordBreak="break-word"
                                  >
                                    Composition: {med.chemicalcomposition}
                                  </Text>
                                )}
                              </Box>
                            </Td>
                            {/* <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {formatDoseWithQuantity(med)}
  </Text>
</Td> */}

<Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {getDoseDisplay(med)}
  </Text>
</Td>


                            {/* <Td>
                              <Text 
                                fontSize={scaleOut ? "xs" : "sm"}
                                wordBreak="break-word"
                              >
                                {med.frequencytime && med.frequencyvalue
                                  ? med.frequencytime === "Hours"
                                    ? `Every ${med.frequencyvalue} ${med.frequencytime}`
                                    : `${med.frequencytime} ${
                                        med.frequencyvalue === 1
                                          ? "once"
                                          : med.frequencyvalue === 2
                                          ? "twice"
                                          : med.frequencyvalue === 3
                                          ? "thrice"
                                          : `${med.frequencyvalue} times`
                                      }`
                                  : `${med.morning || "0"} - ${
                                      med.afternoon || "0"
                                    } - ${med.night || "0"}`}
                              </Text>
                            </Td> */}
                            <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {(med.medicinetype || med.type || "").toLowerCase() === "syrup"
      ? (med.timing || "After Food")
      : isTopicalType(med)
        ? (med.applicationtiming || "-")
        : (med.timing || "After Food")}
        {/* {isTopicalType(med)
      ? (med.applicationtiming || "-")
      : med.timing || "After Food"} */}
  </Text>
</Td>

                            {/* <Td>
                              <Text 
                                fontSize={scaleOut ? "xs" : "sm"}
                                wordBreak="break-word"
                              >
                                {med.timing || "After Food"} - {med.frequency || "1"} Qty
                              </Text>
                            </Td> */}
                            <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {isTopicalType(med)
      ? "Regular"
      : med?.duration !== -1
      ? `${med.duration || "0"} days`
      : "Regular"}
  </Text>
</Td>

<Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {calculateQty(med)}
  </Text>
</Td>
                            <Td>
                              <Text fontSize={scaleOut ? "xs" : "sm"}>
                                {isTopicalType(med) ? (med.wheretoapply || "-") : "-"}
                              </Text>
                            </Td>

                            {/* <Td>
  <Text fontSize={scaleOut ? "xs" : "sm"}>
    {calculateTotalQty(med)}
  </Text>
</Td> */}

                          </Tr>
                          {med.customtext && (
                            <Tr>
                              <Td
                                // colSpan={4}
                              colSpan={6}
                                fontSize={scaleOut ? "xs" : "sm"}
                                pl={6}
                                pt={0}
                                pb={2}
                                borderBottom="1px solid #e2e8f0"
                              >
                                <Text fontWeight="medium" display="inline">
                                  Instructions:{" "}
                                </Text>
                                <Text display="inline">{med.customtext}</Text>
                              </Td>
                            </Tr>
                          )}
                          {/* Instructions Row - Full width */}
                          {/* {med.customtext && (
                            <Tr>
                              <Td 
                                colSpan={4} 
                                // bg="#f8f9fa"
                                borderTop="1px dashed #e2e8f0"
                                py="6px"
                              >
                                <Box pl={2}>
                                  <Text 
                                    fontSize={scaleOut ? "xs" : "sm"}
                                    wordBreak="break-word"
                                    whiteSpace="pre-wrap"
                                    display="flex"
                                    alignItems="flex-start"
                                  >
                                    <Text 
                                      as="span" 
                                      fontWeight="medium" 
                                      minWidth="80px"
                                      flexShrink={0}
                                    >
                                      Instructions: 
                                    </Text>
                                    <Text as="span" ml={1}>
                                      {med.customtext}
                                    </Text>
                                  </Text>
                                </Box>
                              </Td>
                            </Tr>
                          )} */}
                        </React.Fragment>
                      ))}
                    </Tbody>
                  </Table>
                </Box>

                {/* Medicine Table existing */}
                {/* <Box
                  mt={pageIndex === 0 ? 2 : 0}
                  mb="60px"
                  position="relative"
                >
                  <Table
                    variant="simple"
                    size="sm"
                    border="1px solid #e2e8f0"
                    borderRadius="lg"
                    width="100%"
                    sx={{
                      tableLayout: "fixed",
                      "& th, & td": {
                        padding: scaleOut ? "4px 6px" : "8px 10px",
                        fontSize: scaleOut ? "11px" : "13px",
                        verticalAlign: "top",
                      },
                    }}
                  >
                    <Thead bg="#fafafa">
                      <Tr>
                        <Th width="45%">Medicine</Th>
                        <Th width="15%">Dose</Th>
                        <Th width="20%">Timing - Quantity</Th>
                        <Th width="15%" whiteSpace="normal">
                          Where to apply
                        </Th>
                        <Th width="15%">Duration</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {medicineChunk.map((med, index) => (
                        <React.Fragment key={index}>
                          <Tr>
                            <Td fontWeight="bold">
                              <Box>
                                <Text
                                  fontSize={scaleOut ? "xs" : "sm"}
                                  fontWeight="bold"
                                  noOfLines={2}
                                >
                                  {currentOffset + index + 1}.{" "}
                                  {formatMedicineName(med)}
                                  {med.dosageforprescription &&
                                    ` (${med.dosageforprescription})`}
                                </Text>
                                {med.chemicalcomposition && (
                                  <Text
                                    fontSize="9px"
                                    color="gray.500"
                                    mt="1px"
                                    fontStyle="italic"
                                  >
                                    Composition: {med.chemicalcomposition}
                                  </Text>
                                )}
                              </Box>
                            </Td>
                            <Td>
                              <Text fontSize={scaleOut ? "xs" : "sm"}>
                                {med.frequencytime && med.frequencyvalue
                                  ? med.frequencytime === "Hours"
                                    ? `Every ${med.frequencyvalue} ${med.frequencytime}`
                                    : `${med.frequencytime} ${
                                        med.frequencyvalue === 1
                                          ? "once"
                                          : med.frequencyvalue === 2
                                          ? "twice"
                                          : med.frequencyvalue === 3
                                          ? "thrice"
                                          : `${med.frequencyvalue} times`
                                      }`
                                  : `${med.morning || "0"} - ${
                                      med.afternoon || "0"
                                    } - ${med.night || "0"}`}
                              </Text>
                            </Td>
                            <Td>
                              <Text fontSize={scaleOut ? "xs" : "sm"}>
                                {(med.medicinetype?.toLowerCase() === "cream" || med.medicinetype?.toLowerCase() === "ointment" || med.medicinetype?.toLowerCase() === "gel")
                                  ? (med.applicationtiming ? (med.applicationtiming + " - " + (med.frequency || "1") + " Qty") : "-")
                                  : ((med.timing || "After Food") + " - " + (med.frequency || "1") + " Qty")}
                              </Text>
                            </Td>
                            {hasTopicalMedicines() && (med.medicinetype?.toLowerCase() === "cream" || med.medicinetype?.toLowerCase() === "ointment" || med.medicinetype?.toLowerCase() === "gel") && (
                              <Td>
                                <Text fontSize={scaleOut ? "xs" : "sm"}>
                                  {med.wheretoapply || "-"}
                                </Text>
                              </Td>
                            )}
                            {hasTopicalMedicines() && !(med.medicinetype?.toLowerCase() === "cream" || med.medicinetype?.toLowerCase() === "ointment" || med.medicinetype?.toLowerCase() === "gel") && (
                              <Td></Td>
                            )}
                            <Td>
                              <Text fontSize={scaleOut ? "xs" : "sm"}>
                                {(med.medicinetype?.toLowerCase() === "cream" || med.medicinetype?.toLowerCase() === "ointment" || med.medicinetype?.toLowerCase() === "gel")
                                  ? "Regular"
                                  : med?.duration !== -1
                                  ? `${med.duration || "0"} days`
                                  : "Regular"}
                              </Text>
                            </Td>
                          </Tr>
                          {med.customtext && (
                            <Tr>
                              <Td
                                colSpan={hasTopicalMedicines() ? 5 : 4}
                                fontSize={scaleOut ? "xs" : "sm"}
                                pl={6}
                                pt={0}
                                pb={2}
                                borderBottom="1px solid #e2e8f0"
                              >
                                <Text fontWeight="medium" display="inline">
                                  Instructions:{" "}
                                </Text>
                                <Text display="inline">{med.customtext}</Text>
                              </Td>
                            </Tr>
                          )}
                        </React.Fragment>
                      ))}
                    </Tbody>
                  </Table>
                </Box> */}

                {/* Footer Section for Default Templates */}
              </Box>
            )}

                {/* Follow-up and Referral */}
                {(templateid !== 3 && templateid !== 4) && (
                  <>
        <HStack
          justify="center"
          // width={"95%"}
          width={"100%"}
          zIndex={"1"}
          position="absolute"
          bottom={"60px"}
        >
          <VStack
            align="flex-start"
            // width={"65%"}
            width={"68%"}
            border={"1px"}
            borderRadius={"lg"}
            height={scaleOut ? "3rem" : "auto"}
            p={scaleOut ? "1px" : "8px"}
            px={scaleOut ? "8px" : "8px"}
            zIndex={"1"}
            bg={"white"}
            opacity={"100%"}
            ml={"16px"} //newly added tag
          >
            <Grid templateColumns="auto 1fr" gap={scaleOut ? 0 : 2} width="100%">
              {/* Follow-up */}
              {/* <Text minW="90px" fontWeight="medium">Follow-up:</Text>
      <Text>
        <b>{followUpDate}</b>
      </Text> */}
              <Text>Follow-up:</Text>
              <Text pl="48px">
                <b>{followUpDate}</b>
              </Text>

              {/* Referral */}
               {/* <Text minW="90px" fontWeight="medium">Referral:</Text>
      <Text>
        <b>{referralDoctor}</b>
      </Text> */}
              <Text>Referral:</Text>
              <Text pl="48px">
                <b>{referralDoctor}</b>
              </Text>
            </Grid>
          </VStack>

          <VStack
            align="flex-start"
            // width={"30%"}
            width={"28%"}
            border={"1px"}
            borderRadius={"lg"}
            height={scaleOut ? "3rem" : "5rem"}
            p={"8px"}
            bg={"white"}
            opacity={"100%"}
            mr={"16px"}
          >
            <Flex justifyContent="space-between" width="100%" alignItems="center">
              <Text>Signature</Text>
              <Text fontSize='0.75rem' fontWeight='500'>{time}</Text>
            </Flex>
              {doctorSignImage && (
                // <Image src={Esign} alt="Doctor's Signature" />
                <Text className="Esignature" w='100%' textAlign='center' dangerouslySetInnerHTML={{ __html: Esign }} />
              )}
          </VStack>
        </HStack>
            {/* Watermark Background */}
      <Box
        position="absolute"
        bottom={"40px"}
        width="100%"
        height="auto"
        zIndex={0}
      >
        <Box position="absolute" left="0" bottom="0" width="50%" height="auto">
          <img
            src="assets/imgs/PrescriptionVisualBg.png"
            alt="Prescription Background"
            style={{ width: "100%", opacity: 0.8 }}
          />
        </Box>
        <Box position="absolute" right="0" bottom="0" width="50%" height="auto">
          <img
            src="assets/imgs/PrescriptionVisualBg.png"
            alt="Prescription Background"
            style={{ width: "100%", opacity: 0.8 }}
          />
        </Box>
      </Box>
      </>
                )}

            {/* Footer for non-template 3/4 */}
            {templateid != 3 && templateid != 4 && (
              <Box
                position="absolute"
                bottom={0}
                width="100%"
                height="40px"
                bg="black"
                display="flex"
                justifyContent="center"
                alignItems="center"
                zIndex={3}
                px={4}
              >
                <Box display="flex" alignItems="center">
                  <Image
                    src="assets/svgs/website-globe.svg"
                    alt="SVG 1"
                    height="8px"
                    cursor="pointer"
                    onClick={() =>
                      (window.location.href = "https://midoc.ai")
                    }
                  />
                  <Image
                    src="assets/svgs/visit-midoc.svg"
                    alt="SVG 2"
                    height="8px"
                    ml={2}
                    cursor="pointer"
                    onClick={() =>
                      (window.location.href = "https://midoc.ai")
                    }
                  />
                </Box>
              </Box>
            )}

            {/* Template 4 Footer */}
            {templateid === 4 && customtemplatevalues && (
              <Box
                position="absolute"
                bottom="0"
                left="0"
                width="100%"
                bg={customtemplatevalues.footerColor || "#000"}
                p="0.75rem"
                h={customtemplatevalues.footer || "40px"}
                zIndex={3}
                className="footerText"
                textAlign="center"
              >
                <div
                  style={{
                    width: "100%",
                    color:
                      customtemplatevalues.footerTextColor ||
                      (customtemplatevalues.footerColor ? "#fff" : "#000"),
                  }}
                  dangerouslySetInnerHTML={{
                    __html: customtemplatevalues.footerHtml || "",
                  }}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  ) : (
    /* Empty prescription state - updated to match if condition structure */
    <Box
      width="215mm"
      height="297mm"
      borderWidth="1px"
      borderColor="gray.200"
      position="relative"
      className="printPdf page-break"
    >
      {/* Side spaces for template 3 */}
      {Number(templateid) === 3 && rightSpaceCss && (
        <Box
          position="absolute"
          right="0"
          top={0}
          height="100%"
          width={rightSpaceCss}
          zIndex={1}
          bg={customtemplatevalues?.headerColor || "white"}
          borderLeft="1px solid #e6e6e6"
        />
      )}
      {Number(templateid) === 3 && leftSpaceCss && (
        <Box
          position="absolute"
          left={0}
          top={0}
          height="100%"
          width={leftSpaceCss}
          zIndex={1}
          bg={customtemplatevalues?.headerColor || "white"}
          borderRight="1px solid #e6e6e6"
        />
      )}

      {/* Header Section (only for non-template-3) */}
      {templateid !== 3 && templateid !== 4 && (
        <>
          <Box mt="0px" width="100%" height="8px" bg="blue.600" />
          <Box bg="#fafafa">
            <HStack justify="space-between" pt={3} px={4}>
              <VStack align="flex-start" spacing={1}>
                <Text fontWeight="bold" fontSize="xl">
                  {drName}
                </Text>
                <Text>
                  {doctorQualification}, {doctorSpeciality}
                </Text>
              </VStack>
              <HStack spacing={4} px={4}>
                {partnerData.slice(0, 3).map((partner, index) => (
                  <Box
                    key={index}
                    ml={index > 0 ? 2 : 0}
                    display="flex"
                    alignItems="center"
                    style={{ position: "relative", top: "-4px" }}
                  >
                    {partner.partnerlogo ? (
                      <Image
                        src={partner.imagepath + partner.partnerlogo}
                        alt={`Partner Logo ${index + 1}`}
                        height="40px"
                        width="40px"
                        borderRadius="50%"
                        cursor="pointer"
                      />
                    ) : (
                      <Box
                        color="black"
                        height="40px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        borderRadius="4px"
                        cursor="pointer"
                      >
                        {partner.partnername.trim()}
                      </Box>
                    )}
                  </Box>
                ))}
                <Box
                  ml="0"
                  display="flex"
                  alignItems="center"
                  style={{ position: "relative", top: "-4px" }}
                >
                  {hospitalLogo && (
                    <img
                      src={hospitalLogo}
                      alt="Hospital Logo"
                      height="40px"
                      width="40px"
                    />
                  )}
                </Box>
                <Image src="assets/svgs/bigLineLogo.svg" alt="Big Line Logo" />
                <Image
                  src="assets/svgs/miDocLogo.svg"
                  alt="miDoc Logo"
                  height="40px"
                  mr="36px"
                />
              </HStack>
            </HStack>

            <HStack justify="flex-start" mt={1} px={4}>
              <HStack>
                <Image src="assets/svgs/call.svg" alt="Call" />
                <Text fontSize="xs">
                  {doctorPhoneCountryCode && `(${doctorPhoneCountryCode}) `}
                  {doctorPhone}
                </Text>
              </HStack>
              <HStack>
                <Image src="assets/svgs/smallLinePhoneMail.svg" alt="Divider" />
                <Image src="assets/svgs/mail-gray.svg" alt="Mail" />
                <Text fontSize="xs">{doctorMail}</Text>
              </HStack>
            </HStack>

            <HStack justify="flex-start" mt={1} px={4}>
              <Image
                src="assets/svgs/hospital-location-on.svg"
                alt="Location"
              />
              <Text fontSize="xs">{hospitalAddress}</Text>
            </HStack>
          </Box>
        </>
      )}

      {/* Template 4 Header */}
      {templateid === 4 && (
        <Box bg={customtemplatevalues?.headerColor || "#fafafa"} p="0.75rem">
          <div
            style={{ width: "100%" }}
            dangerouslySetInnerHTML={{
              __html: customtemplatevalues?.headerHtml || "",
            }}
          />
        </Box>
      )}

      {/* Main Content Area - Dynamically positioned between side spaces */}
      {templateid === 3 || templateid === 4 ? (
      <Box
        position="absolute"
        left={Number(templateid) === 3 && leftSpace ? leftSpace : 0}
        right={Number(templateid) === 3 && rightSpaceCss ? rightSpaceCss : 0}
        top={0}
        bottom={0}
        p={scaleOut ? 1 : 4}
        px={scaleOut ? 2 : 4}
        pt={Number(templateid) === 3 ? "16px" : "16px"}
        overflow="hidden"
        display="flex"
        flexDirection="column"
      >
        {/* Patient Information Section */}
        <VStack align="flex-start" mt={scaleOut ? "1px" : "4px"} width="100%">
          <HStack
            width="100%"
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <VStack spacing={1} align="start" width="100%">
              <HStack width="100%" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  # {patientBookingId}
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={scaleOut ? "sm" : "md"}
                  flex={1}
                  minWidth={0}
                >
                  {patientName && `${patientName}, `}
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  {patientmrnnumber && `#${patientmrnnumber}`}
                </Text>
              </HStack>

              <HStack width="100%" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Details:
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={scaleOut ? "sm" : "md"}
                  flex={1}
                  minWidth={0}
                  wordBreak="break-word"
                >
                  {[
                    patientGender &&
                      patientGender.charAt(0).toUpperCase() +
                        patientGender.slice(1),
                    patientAge && `${patientAge} Yrs`,
                    patientPhone &&
                      `${
                        patientPhoneCountryCode
                          ? `(${patientPhoneCountryCode}) `
                          : ""
                      }${patientPhone}`,
                    appointmentDate,
                    ...(vitalData && Array.isArray(vitalData)
                      ? vitalData
                          .filter(
                            (vital) =>
                              vital.type === "Weight" || vital.type === "Height"
                          )
                          .map(
                            (vital) => `VITAL|${vital.type}|${vital.value}`
                          )
                      : []),
                  ]
                    .filter(Boolean)
                    .map((item, index, arr) => {
                      const isVital = item.startsWith("VITAL|");

                      if (isVital) {
                        const [, label, value] = item.split("|");
                        return (
                          <Box as="span" key={index}>
                            <b>{label}</b>:{" "}
                            <Text as="span" fontWeight="normal">
                              {value}
                            </Text>
                            {index !== arr.length - 1 ? ", " : ""}
                          </Box>
                        );
                      }

                      return (
                        <Box as="span" key={index}>
                          {item}
                          {index !== arr.length - 1 ? ", " : ""}
                        </Box>
                      );
                    })}
                </Text>
              </HStack>
            </VStack>

            {templateid == 3 && (
              <Image
                src="assets/svgs/miDocLogo.svg"
                alt="miDoc Logo"
                height="40px"
                ml="16px"
                flexShrink={0}
              />
            )}
          </HStack>

          {services && (
            <HStack width="100%" mt="4px" alignItems="flex-start">
              <Text
                width={`${middleSectionHeaderWidth}%`}
                fontSize={scaleOut ? "sm" : "md"}
                flexShrink={0}
              >
                Services:
              </Text>
              <Text
                fontWeight="bold"
                fontSize={scaleOut ? "sm" : "md"}
                width={`${100 - middleSectionHeaderWidth}%`}
                wordBreak="break-word"
              >
                {options.join(", ")}
              </Text>
            </HStack>
          )}

          <Divider my={scaleOut ? 1 : 2} />

          {settings && settings.chiefcomplaint === 1 && chiefcomplaint && (
            <HStack width="100%" mt="4px" alignItems="flex-start">
              <Text
                width={`${middleSectionHeaderWidth}%`}
                fontSize={scaleOut ? "sm" : "md"}
                flexShrink={0}
              >
                Complaints:
              </Text>
              <Text
                fontWeight="bold"
                fontSize={scaleOut ? "sm" : "md"}
                flex={1}
                wordBreak="break-word"
              >
                {chiefcomplaint}
              </Text>
            </HStack>
          )}

          {settings &&
            settings.hpi === 1 &&
            (hpitext || (hpi && hpi.length > 0)) && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Present Illness:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  wordBreak="break-word"
                >
                  {hpitext ? (
                    <>{hpitext}</>
                  ) : (
                    generateDynamicText(hpi).map((text, index) => (
                      <React.Fragment key={index}>{text}</React.Fragment>
                    ))
                  )}
                </Text>
              </HStack>
            )}

          {settings &&
            settings.vitals === 1 &&
            vitalData &&
            vitalData.length > 0 && (
              <HStack width="100%" gap="20px" alignItems="flex-start">
                <Box w="20%">
                  <Text
                    width="100%"
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Vitals:
                  </Text>
                </Box>
                <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                  {vitalData
                    .filter(
                      (vital) =>
                        vital.type !== "Weight" && vital.type !== "Height"
                    )
                    .map((vital, index) => (
                      <Text
                        key={index}
                        fontSize={
                          scaleOut || vitalData.length > 3 ? "sm" : undefined
                        }
                      >
                        <b>{vital.type}</b>: {vital.value} {vital.unit}
                      </Text>
                    ))}
                </Box>
              </HStack>
            )}

          {settings &&
            settings.physicalexam === 1 &&
            physicalexam &&
            physicalexam.length > 0 && (
              <HStack width="100%" gap="20px" alignItems="flex-start">
                <Box w="20%">
                  <Text
                    width="100%"
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Physical Exam:
                  </Text>
                </Box>
                <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                  {physicalexam.map((exam, index) => (
                    <Text
                      key={index}
                      fontSize={
                        scaleOut || physicalexam.length > 3 ? "sm" : undefined
                      }
                    >
                      <b>{exam.type}</b>: {exam.condition}
                      {exam.notes ? `, ${exam.notes}` : ""}
                    </Text>
                  ))}
                </Box>
              </HStack>
            )}

          {settings && settings.ros === 1 && ros && ros.length > 0 && (
            <HStack width="100%" gap="20px" alignItems="flex-start">
              <Box w="20%">
                <Text
                  width="100%"
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Review of system:
                </Text>
              </Box>
              <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                {ros.map((exam, index) => (
                  <Text
                    key={index}
                    fontSize={scaleOut || ros.length > 3 ? "sm" : undefined}
                  >
                    <b>{exam.type}</b>: {exam.condition}
                  </Text>
                ))}
              </Box>
            </HStack>
          )}

          {Array.isArray(investigationData) &&
            investigationData.filter((i) => i?.value).length > 0 && (
              <HStack width="100%" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Investigations:
                </Text>
                <Box display="flex" flexWrap="wrap" gap="10px" flex={1}>
                  {investigationData.map((investigate, index) => (
                    <Text
                      key={index}
                      fontSize={
                        scaleOut || investigationData.length > 3
                          ? "sm"
                          : undefined
                      }
                    >
                      <b>{investigate.type}</b>: {investigate.value}{" "}
                      {investigate.unit}
                    </Text>
                  ))}
                </Box>
              </HStack>
            )}

          {settings &&
            settings.assessment === 1 &&
            (patientdiagnosis || chunkedDiagnosisData?.length > 0) && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Diagnosis:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  fontWeight="bold"
                  wordBreak="break-word"
                >
                  {patientdiagnosis}
                  {patientdiagnosis && chunkedDiagnosisData?.length > 0
                    ? ", "
                    : ""}
                  {chunkedDiagnosisData?.flat()?.join(", ")}
                </Text>
              </HStack>
            )}

          {Array.isArray(chunkedMedicalHistory) &&
            chunkedMedicalHistory.flat().filter(Boolean).length > 0 && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Medical History:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  fontWeight="bold"
                  wordBreak="break-word"
                >
                  {chunkedMedicalHistory.flat().join(", ")}
                </Text>
              </HStack>
            )}

          {Array.isArray(chunkedRecommendedTests) &&
            chunkedRecommendedTests.flat().filter(Boolean).length > 0 && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Recommended Tests:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  fontWeight="bold"
                  wordBreak="break-word"
                >
                  {chunkedRecommendedTests
                    .flat()
                    .filter(Boolean)
                    .map((test, index, array) => (
                      <span key={index}>
                        {test}
                        {index !== array.length - 1 ? ", " : ""}
                      </span>
                    ))}
                </Text>
              </HStack>
            )}

          {Array.isArray(chunkedDieticianNotes) &&
            chunkedDieticianNotes.flat().filter(Boolean).length > 0 && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Dietician Notes:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  fontWeight="bold"
                  wordBreak="break-word"
                >
                  {chunkedDieticianNotes.flat().join(", ")}
                </Text>
              </HStack>
            )}

          {Array.isArray(chunkedGeneralNotes) &&
            chunkedGeneralNotes.flat().filter(Boolean).length > 0 && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  General Notes:
                </Text>
                <Text
                  width={`${100 - middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  fontWeight="bold"
                  wordBreak="break-word"
                >
                  {chunkedGeneralNotes.flat().join(", ")}
                </Text>
              </HStack>
            )}
        </VStack>

        {/* Only show spacing/divider when there is content above */}
        {(
          (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
          (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
          (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
          (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
          (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
        ) && (
          <Divider my={scaleOut ? 1 : 3} />
        )}

        {/* Prescription Header */}
        <HStack
          mt={
            (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
            (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
              ? 3
              : 1
          }
        >
          <Image
            src="assets/svgs/Rx.svg"
            alt="Rx"
            boxSize={scaleOut ? "12px" : "24px"}
          />
          <Text fontWeight="bold" fontSize={scaleOut ? "sm" : "lg"}>
            Prescription
          </Text>
        </HStack>

        {/* Medicine Table - Scrollable container */}
        <Box
          flex={1}
          mt={1}
          mb="80px"
        >
          <Table
            variant="simple"
            size="sm"
            border="1px solid #e2e8f0"
            borderRadius="lg"
            width="100%"
            sx={{
              tableLayout: "fixed",
              "& th, & td": {
                padding: scaleOut ? "2px 4px" : "4px 8px",
                fontSize: scaleOut ? "10px" : "12px",
                lineHeight: 1.2,
                verticalAlign: "top",
              },
            }}
          >
            <Thead bg="#fafafa">
              <Tr>
                <Th width="45%">Medicine</Th>
                <Th width="15%">Dose</Th>
                <Th width="20%">Timing</Th>
                <Th width="15%" minWidth="60px">Duration</Th>
                <Th width="15%" minWidth="60px">QTY</Th>
                <Th width="15%" whiteSpace="normal">
                  Where to apply
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td colSpan={6} textAlign="center" py={8}>
                  <Text fontSize="sm" color="gray.500">
                    No medicines prescribed
                  </Text>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>

        {/* Fixed Footer Section */}
        <Box
          position="absolute"
          left={Number(templateid) === 3 && leftSpaceCss ? leftSpaceCss : 0}
          right={Number(templateid) === 3 && rightSpaceCss ? rightSpaceCss : 0}
          bottom={
            Number(templateid) === 3 && bottomSpaceCssUsed
              ? bottomSpaceCssUsed
              : "20px"
          }
          width="100%"
          zIndex={2}
        >
          <Box position="relative">
            {/* Watermark */}
            <Box
              position="absolute"
              bottom="0"
              left="0"
              width="100%"
              height="150%"
              zIndex={0}
              opacity={0.8}
              pointerEvents="none"
              overflow="hidden"
            >
              <Box position="absolute" left="0" bottom="0" width="50%">
                <img
                  src="assets/imgs/PrescriptionVisualBg.png"
                  alt="Watermark"
                  style={{ width: "100%" }}
                />
              </Box>
              <Box position="absolute" right="0" bottom="0" width="50%">
                <img
                  src="assets/imgs/PrescriptionVisualBg.png"
                  alt="Watermark"
                  style={{ width: "100%" }}
                />
              </Box>
            </Box>

            {/* Footer Content */}
            {/* <Box position="relative" zIndex={2} px={scaleOut ? 2 : 4}> */}
            <Box position="relative" zIndex={2}>
              <HStack justify="center" width="100%">
                <VStack
                  align="flex-start"
                  width="65%"
                  border="1px solid #e2e8f0"
                  borderRadius="lg"
                  p={scaleOut ? "6px" : "10px"}
                  bg="white"
                  position="relative"
                  zIndex={2}
                >
                  <Grid
                    templateColumns={scaleOut ? "auto 1fr" : "100px 1fr"}
                    gap={scaleOut ? 1 : 2}
                    alignItems="center"
                  >
                    <Text fontSize={scaleOut ? "xs" : "sm"}>Follow-up:</Text>
                    <Text fontSize={scaleOut ? "xs" : "sm"}>
                      <b>{followUpDate || "-"}</b>
                    </Text>
                    <Text fontSize={scaleOut ? "xs" : "sm"}>Referral:</Text>
                    <Text fontSize={scaleOut ? "xs" : "sm"}>
                      <b>{referralDoctor || "-"}</b>
                    </Text>
                  </Grid>
                </VStack>

                <VStack
                  align="flex-start"
                  width="30%"
                  border="1px solid #e2e8f0"
                  borderRadius="lg"
                  p={scaleOut ? "6px" : "10px"}
                  bg="white"
                  height={scaleOut ? "3rem" : "5rem"}
                  position="relative"
                  zIndex={2}
                >
                  <Flex justify="space-between" width="100%" alignItems="center">
                    <Text fontSize={scaleOut ? "xs" : "sm"}>Signature</Text>
                    <Text fontSize={scaleOut ? "10px" : "0.75rem"} fontWeight="500">
                      {time}
                    </Text>
                  </Flex>
                  {doctorSignImage && (
                    <Text
                      className="Esignature"
                      w="100%"
                      textAlign="center"
                      fontSize={scaleOut ? "10px" : "sm"}
                      dangerouslySetInnerHTML={{ __html: Esign }}
                    />
                  )}
                </VStack>
              </HStack>
            </Box>
          </Box>
        </Box>
      </Box>
      ) : (
        /* NEW STRUCTURE FOR DEFAULT TEMPLATES (1 & 2) - NO MEDICINES */
        <Box
          p={scaleOut ? 1 : 4}
          px={scaleOut ? 2 : 4}
          pt="16px"
          pb="auto"
          height="auto"
          position="relative"
        >
          {/* Patient Information Section */}
          <VStack align="flex-start" mt={scaleOut ? "1px" : "4px"} width="100%">
            <HStack width="100%" justifyContent="space-between" alignItems="flex-start">
              <VStack spacing={1} align="start" width="100%">
                <HStack width="100%" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    # {patientBookingId}
                  </Text>
                  <Text
                    fontWeight="bold"
                    fontSize={scaleOut ? "sm" : "md"}
                    flex={1}
                    minWidth={0}
                  >
                    {patientName && `${patientName}, `}
                  </Text>
                  <Text
                    fontWeight="bold"
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    {patientmrnnumber && `#${patientmrnnumber}`}
                  </Text>
                </HStack>

                <HStack width="100%" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Details:
                  </Text>
                  <Text
                    fontWeight="bold"
                    fontSize={scaleOut ? "sm" : "md"}
                    flex={1}
                    minWidth={0}
                    wordBreak="break-word"
                  >
                    {[
                      patientGender &&
                        patientGender.charAt(0).toUpperCase() +
                          patientGender.slice(1),
                      patientAge && `${patientAge} Yrs`,
                      patientPhone &&
                        `${
                          patientPhoneCountryCode
                            ? `(${patientPhoneCountryCode}) `
                            : ""
                        }${patientPhone}`,
                      appointmentDate,
                      ...(vitalData && Array.isArray(vitalData)
                        ? vitalData
                            .filter(
                              (vital) =>
                                vital.type === "Weight" || vital.type === "Height"
                            )
                            .map(
                              (vital) => `VITAL|${vital.type}|${vital.value}`
                            )
                        : []),
                    ]
                      .filter(Boolean)
                      .map((item, index, arr) => {
                        const isVital = item.startsWith("VITAL|");

                        if (isVital) {
                          const [, label, value] = item.split("|");
                          return (
                            <Box as="span" key={index}>
                              <b>{label}</b>:{" "}
                              <Text as="span" fontWeight="normal">
                                {value}
                              </Text>
                              {index !== arr.length - 1 ? ", " : ""}
                            </Box>
                          );
                        }

                        return (
                          <Box as="span" key={index}>
                            {item}
                            {index !== arr.length - 1 ? ", " : ""}
                          </Box>
                        );
                      })}
                  </Text>
                </HStack>
              </VStack>
            </HStack>

            {services && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Services:
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={scaleOut ? "sm" : "md"}
                  width={`${100 - middleSectionHeaderWidth}%`}
                  wordBreak="break-word"
                >
                  {options.join(", ")}
                </Text>
              </HStack>
            )}

            <Divider my={scaleOut ? 1 : 2} />

            {settings && settings.chiefcomplaint === 1 && chiefcomplaint && (
              <HStack width="100%" mt="4px" alignItems="flex-start">
                <Text
                  width={`${middleSectionHeaderWidth}%`}
                  fontSize={scaleOut ? "sm" : "md"}
                  flexShrink={0}
                >
                  Complaints:
                </Text>
                <Text
                  fontWeight="bold"
                  fontSize={scaleOut ? "sm" : "md"}
                  flex={1}
                  wordBreak="break-word"
                >
                  {chiefcomplaint}
                </Text>
              </HStack>
            )}

            {settings &&
              settings.hpi === 1 &&
              (hpitext || (hpi && hpi.length > 0)) && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Present Illness:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    wordBreak="break-word"
                  >
                    {hpitext ? (
                      <>{hpitext}</>
                    ) : (
                      generateDynamicText(hpi).map((text, index) => (
                        <React.Fragment key={index}>{text}</React.Fragment>
                      ))
                    )}
                  </Text>
                </HStack>
              )}

            {settings &&
              settings.vitals === 1 &&
              vitalData &&
              vitalData.length > 0 && (
                <HStack width="100%" gap="20px" alignItems="flex-start">
                  <Box w="20%">
                    <Text
                      width="100%"
                      fontSize={scaleOut ? "sm" : "md"}
                      flexShrink={0}
                    >
                      Vitals:
                    </Text>
                  </Box>
                  <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                    {vitalData
                      .filter(
                        (vital) =>
                          vital.type !== "Weight" && vital.type !== "Height"
                      )
                      .map((vital, index) => (
                        <Text
                          key={index}
                          fontSize={
                            scaleOut || vitalData.length > 3 ? "sm" : undefined
                          }
                        >
                          <b>{vital.type}</b>: {vital.value} {vital.unit}
                        </Text>
                      ))}
                  </Box>
                </HStack>
              )}

            {settings &&
              settings.physicalexam === 1 &&
              physicalexam &&
              physicalexam.length > 0 && (
                <HStack width="100%" gap="20px" alignItems="flex-start">
                  <Box w="20%">
                    <Text
                      width="100%"
                      fontSize={scaleOut ? "sm" : "md"}
                      flexShrink={0}
                    >
                      Physical Exam:
                    </Text>
                  </Box>
                  <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                    {physicalexam.map((exam, index) => (
                      <Text
                        key={index}
                        fontSize={
                          scaleOut || physicalexam.length > 3 ? "sm" : undefined
                        }
                      >
                        <b>{exam.type}</b>: {exam.condition}
                        {exam.notes ? `, ${exam.notes}` : ""}
                      </Text>
                    ))}
                  </Box>
                </HStack>
              )}

            {settings && settings.ros === 1 && ros && ros.length > 0 && (
              <HStack width="100%" gap="20px" alignItems="flex-start">
                <Box w="20%">
                  <Text
                    width="100%"
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Review of system:
                  </Text>
                </Box>
                <Box w="100%" display="flex" flexWrap="wrap" gap="10px">
                  {ros.map((exam, index) => (
                    <Text
                      key={index}
                      fontSize={scaleOut || ros.length > 3 ? "sm" : undefined}
                    >
                      <b>{exam.type}</b>: {exam.condition}
                    </Text>
                  ))}
                </Box>
              </HStack>
            )}

            {Array.isArray(investigationData) &&
              investigationData.filter((i) => i?.value).length > 0 && (
                <HStack width="100%" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Investigations:
                  </Text>
                  <Box display="flex" flexWrap="wrap" gap="10px" flex={1}>
                    {investigationData.map((investigate, index) => (
                      <Text
                        key={index}
                        fontSize={
                          scaleOut || investigationData.length > 3
                            ? "sm"
                            : undefined
                        }
                      >
                        <b>{investigate.type}</b>: {investigate.value}{" "}
                        {investigate.unit}
                      </Text>
                    ))}
                  </Box>
                </HStack>
              )}

            {settings &&
              settings.assessment === 1 &&
              (patientdiagnosis || chunkedDiagnosisData?.length > 0) && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Diagnosis:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    fontWeight="bold"
                    wordBreak="break-word"
                  >
                    {patientdiagnosis}
                    {patientdiagnosis && chunkedDiagnosisData?.length > 0
                      ? ", "
                      : ""}
                    {chunkedDiagnosisData?.flat()?.join(", ")}
                  </Text>
                </HStack>
              )}

            {Array.isArray(chunkedMedicalHistory) &&
              chunkedMedicalHistory.flat().filter(Boolean).length > 0 && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Medical History:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    fontWeight="bold"
                    wordBreak="break-word"
                  >
                    {chunkedMedicalHistory.flat().join(", ")}
                  </Text>
                </HStack>
              )}

            {Array.isArray(chunkedRecommendedTests) &&
              chunkedRecommendedTests.flat().filter(Boolean).length > 0 && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Recommended Tests:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    fontWeight="bold"
                    wordBreak="break-word"
                  >
                    {chunkedRecommendedTests
                      .flat()
                      .filter(Boolean)
                      .map((test, index, array) => (
                        <span key={index}>
                          {test}
                          {index !== array.length - 1 ? ", " : ""}
                        </span>
                      ))}
                  </Text>
                </HStack>
              )}

            {Array.isArray(chunkedDieticianNotes) &&
              chunkedDieticianNotes.flat().filter(Boolean).length > 0 && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    Dietician Notes:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    fontWeight="bold"
                    wordBreak="break-word"
                  >
                    {chunkedDieticianNotes.flat().join(", ")}
                  </Text>
                </HStack>
              )}

            {Array.isArray(chunkedGeneralNotes) &&
              chunkedGeneralNotes.flat().filter(Boolean).length > 0 && (
                <HStack width="100%" mt="4px" alignItems="flex-start">
                  <Text
                    width={`${middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    flexShrink={0}
                  >
                    General Notes:
                  </Text>
                  <Text
                    width={`${100 - middleSectionHeaderWidth}%`}
                    fontSize={scaleOut ? "sm" : "md"}
                    fontWeight="bold"
                    wordBreak="break-word"
                  >
                    {chunkedGeneralNotes.flat().join(", ")}
                  </Text>
                </HStack>
              )}
          </VStack>

          {/* Only show spacing/divider when there is content above */}
          {(
            (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
            (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
            (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
          ) && (
            <Divider my={scaleOut ? 1 : 3} />
          )}

          {/* Prescription Header */}
          <HStack
            mt={
              (settings && settings.assessment === 1 && (patientdiagnosis || chunkedDiagnosisData?.length > 0)) ||
              (Array.isArray(chunkedMedicalHistory) && chunkedMedicalHistory.flat().filter(Boolean).length > 0) ||
              (Array.isArray(chunkedRecommendedTests) && chunkedRecommendedTests.flat().filter(Boolean).length > 0) ||
              (Array.isArray(chunkedDieticianNotes) && chunkedDieticianNotes.flat().filter(Boolean).length > 0) ||
              (Array.isArray(chunkedGeneralNotes) && chunkedGeneralNotes.flat().filter(Boolean).length > 0)
                ? 3
                : 1
            }
          >
            <Image
              src="assets/svgs/Rx.svg"
              alt="Rx"
              boxSize={scaleOut ? "12px" : "24px"}
            />
            <Text fontWeight="bold" fontSize={scaleOut ? "sm" : "lg"}>
              Prescription
            </Text>
          </HStack>

          {/* Medicine Table - Empty State */}
          <Box
            mt={1}
            mb="60px"
            position="relative"
          >
            <Table
              variant="simple"
              size="sm"
              border="1px solid #e2e8f0"
              borderRadius="lg"
              width="100%"
              sx={{
                tableLayout: "fixed",
                "& th, & td": {
                  padding: scaleOut ? "4px 6px" : "8px 10px",
                  fontSize: scaleOut ? "11px" : "13px",
                  verticalAlign: "top",
                },
              }}
            >
              <Thead bg="#fafafa">
                <Tr>
                  <Th width="45%">Medicine</Th>
                  <Th width="15%">Dose</Th>
                  <Th width="20%">Timing</Th>
                  <Th width="15%" minWidth="60px">Duration</Th>
                  <Th width="15%" minWidth="60px">QTY</Th>
                  <Th width="15%">Where to Apply</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td colSpan={6} textAlign="center" py={8}>
                    <Text fontSize="sm" color="gray.500">
                      No medicines prescribed
                    </Text>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </Box>

          {/* Footer Section for Default Templates */}
          
        </Box>
      )}
      {/* Follow-up and Referral */}
                {(templateid !== 3 && templateid !== 4) && (
                  <>
        <HStack
          justify="center"
          width={"95%"}
          zIndex={"1"}
          position="absolute"
          bottom={"60px"}
        >
          <VStack
            align="flex-start"
            width={"65%"}
            border={"1px"}
            borderRadius={"lg"}
            height={scaleOut ? "3rem" : "auto"}
            p={scaleOut ? "1px" : "8px"}
            px={scaleOut ? "8px" : "8px"}
            zIndex={"1"}
            bg={"white"}
            opacity={"100%"}
          >
            <Grid templateColumns="auto 1fr" gap={scaleOut ? 0 : 2}>
              {/* Follow-up */}
              <Text>Follow-up:</Text>
              <Text pl="48px">
                <b>{followUpDate}</b>
              </Text>

              {/* Referral */}
              <Text>Referral:</Text>
              <Text pl="48px">
                <b>{referralDoctor}</b>
              </Text>
            </Grid>
          </VStack>

          <VStack
            align="flex-start"
            width={"30%"}
            border={"1px"}
            borderRadius={"lg"}
            height={scaleOut ? "3rem" : "5rem"}
            p={"8px"}
            bg={"white"}
            opacity={"100%"}
          >
            <Flex justifyContent="space-between" width="100%" alignItems="center">
              <Text>Signature</Text>
              <Text fontSize='0.75rem' fontWeight='500'>{time}</Text>
            </Flex>
              {doctorSignImage && (
                // <Image src={Esign} alt="Doctor's Signature" />
                <Text className="Esignature" w='100%' textAlign='center' dangerouslySetInnerHTML={{ __html: Esign }} />
              )}
          </VStack>
        </HStack>
            {/* Watermark Background */}
      <Box
        position="absolute"
        bottom={"40px"}
        width="100%"
        height="auto"
        zIndex={0}
      >
        <Box position="absolute" left="0" bottom="0" width="50%" height="auto">
          <img
            src="assets/imgs/PrescriptionVisualBg.png"
            alt="Prescription Background"
            style={{ width: "100%", opacity: 0.8 }}
          />
        </Box>
        <Box position="absolute" right="0" bottom="0" width="50%" height="auto">
          <img
            src="assets/imgs/PrescriptionVisualBg.png"
            alt="Prescription Background"
            style={{ width: "100%", opacity: 0.8 }}
          />
        </Box>
      </Box>
      </>
                )}

      {/* Footer for non-template 3/4 */}
      {templateid != 3 && templateid != 4 && (
        <Box
          position="absolute"
          bottom={0}
          width="100%"
          height="40px"
          bg="black"
          display="flex"
          justifyContent="center"
          alignItems="center"
          zIndex={3}
          px={4}
        >
          <Box display="flex" alignItems="center">
            <Image
              src="assets/svgs/website-globe.svg"
              alt="SVG 1"
              height="8px"
              cursor="pointer"
              onClick={() => (window.location.href = "https://midoc.ai")}
            />
            <Image
              src="assets/svgs/visit-midoc.svg"
              alt="SVG 2"
              height="8px"
              ml={2}
              cursor="pointer"
              onClick={() => (window.location.href = "https://midoc.ai")}
            />
          </Box>
        </Box>
      )}

      {/* Template 4 Footer */}
      {templateid === 4 && customtemplatevalues && (
        <Box
          position="absolute"
          bottom="0"
          left="0"
          width="100%"
          bg={customtemplatevalues.footerColor || "#000"}
          p="0.75rem"
          h={customtemplatevalues.footer || "40px"}
          zIndex={3}
          className="footerText"
          textAlign="center"
        >
          <div
            style={{
              width: "100%",
              color:
                customtemplatevalues.footerTextColor ||
                (customtemplatevalues.footerColor ? "#fff" : "#000"),
            }}
            dangerouslySetInnerHTML={{
              __html: customtemplatevalues.footerHtml || "",
            }}
          />
        </Box>
      )}
    </Box>
  )}
  
  {/* Document pages */}
  {documents && documents.length > 0 &&
    documents.map((doc, index) => (
      <Box
        key={`document-page-${index}`}
        width="215mm"
        height="297mm"
        borderWidth="1px"
        borderColor="gray.200"
        position="relative"
        className="printPdf page-break"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bg="white"
      >
        <Image
          src={doc.image}
          alt={`Document Page ${index + 2}`}
          maxHeight="100%"
          maxWidth="100%"
          objectFit="contain"
        />
      </Box>
    ))}
</Box>
  </Box>
  );
};

export default Prescription;
